import { Component, NgModule, trigger, transition, style, animate, state } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import "aws-sdk/dist/aws-sdk.min";

import { DispatcherService } from './dispatcher.service';
import { LoginService } from '../login/login.service';
import { MissionService } from '../app.constant';
import * as myGlobals from '../globals';
import { ConfigService } from '../config.service';
import { LanguageService } from '../language.service';
import { HaversineService, GeoCoord } from 'ng2-haversine';
import { MqttService } from '../mqtt.service';
import { DispatcherHomeService } from './dispatcherhome/dispatcherhome.service';

declare const jQuery: any;
declare var google: any;
declare var $: any;
declare var flatpickr: any;
declare var screenfull: any;
declare var Stripe: any;
declare var moment: any;
declare var swal: any;
declare var unescape: any;
declare var toastr: any;

@Component({
  selector: 'dispatcher',
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
          style({ transform: 'translateY(100%)', opacity: 0 }),
          animate('400ms', style({ transform: 'translateY(0)', 'opacity': 1 }))
        ]
        ),
        transition(
          ':leave', [
          style({ transform: 'translateY(0)', 'opacity': 1 }),
          animate('400ms', style({ transform: 'translateY(100%)', 'opacity': 0 }),
          )
        ]
        )]
    )
  ],
  templateUrl: './dispatcher.component.html',
  styleUrls: ['./dispatcherhome/dispatcherhome.component.css', './dispatcher.component.css']
})
export class DispatcherComponent {
  online$: Observable<boolean>;
  disphome: any;
  booknow: any;
  addcard: any;
  booklater: any;
  bookcomplete: any;
  invoice: any;
  langtask: any;
  vehicle_types1: any;
  errvehicle: any;
  errmessage: any;
  errMsg: any;
  item: any;
  veh_id: any;
  vehicleStatus: any;
  date: any;
  time: any = new Date().toLocaleTimeString();
  seats = 1;
  promoCode: any;
  verifyPromo: any;
  gender = 0;
  wheelChairSupport = 0;
  boosterseat = 0;
  extrabag = 0;
  quiteride = 0;
  bikecarrier = 0;
  booknowbutton = true;
  booklaterbutton = true;
  walletPay: any;
  specialPickups: any;
  speciallat: any;
  speciallong: any;
  speciallatlong: any = [];
  specialpickupmarker: any;
  specialAddress: any;

  meters: any;
  kilometers: any;
  est: any;
  apres: any;
  fp_incr: any;
  driverlat;
  driverlong;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  photo = [];
  vechiletypes: any;
  approx: any;
  approx_dist: any;
  vehicle_device_id: any;
  info;
  Path;
  zpath: any;
  getdata;
  own_drop_latlong: any;
  own_lat_long: any;
  own_later_date;
  own_drop_date: any;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  company_name: any;
  rec_lat_long: any;
  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file = [];
  data: any;
  fname_b: any;
  map: any;
  markers = [];
  style: any;
  fmail_b: any;
  email: any;
  myphone: any;
  mymail: any;
  myname: any;
  first_name: any;
  phone: any;
  public form: FormGroup;
  public phoneNumber: AbstractControl;
  public password: AbstractControl;
  public submitted: boolean = false;
  current_time: any;
  current_time_var: any;
  zone_one_title: any;
  zone_amount: any;
  zone_two_title: any;
  journey_time: any;
  increment_num: number = 1;
  notify_bid: any;
  notify_sid: any = 0;
  approx_amount: any;
  map_variable: number = 0;
  booking_time: any;
  appt_type: number;
  zone_id_pick: any;
  zone_id_drop: any;
  notifications = [];
  result: any;
  change_pos: any;
  //current lat long varbles
  current_lat: any;
  current_lng: any;
  // vehicle types;
  vehicle_types = [];
  vehicle_bool = true;
  //map varaibles
  mappickup_drop_bounds: any;
  mapdriver_drop_bounds: any;
  pickup_marker_loc: any;
  drop_marker_loc: any;
  driver_marker_loc: any;
  // livebooking variables
  vehicle_id: any;
  zone_one_id: any;
  zone_two_id: any;
  time_fare: any;
  dist_fare: any;
  dist: any;
  tme: any;
  pricingType: any;
  //cards validation bools
  visa = false;
  amex = false;
  diners = false;
  discover = false;
  master = false;
  jcb = false;
  card_number_all: any;
  card_month: any;
  card_year: any;
  card_cvc: any;
  allcards = [];
  show_add_card = false;
  duration: any;
  timeFare: any;
  distFare: any;
  distance: any;
  goods_type_list = [];
  approx_dist_txt: any;
  category_id: any;
  category_name: any;
  show_error_bool = false;
  // new user validation
  signup_name: any;
  signup_mail: any;
  signup_number: any;
  mail_bool = false;
  phone_bool = false;
  pickup_bool = true;
  pickup_loc_bool = false;
  drop_loc_bool = false;
  drop_bool = true;
  signup_otpcode: any;
  timer_i: any;
  counter_bool = false;
  drivers_vehicletype = [];
  drivers_vehicletype_markers = [];
  applied_amt;
  card_number = '';
  checking_vehs = false;
  pickup_ok = false;
  vehicles_empty = false;
  change_quantity = false;
  vehicles_interval: any;
  show_cards_hide = false;
  authorize_call: any;
  directionsDisplay: any;
  estimate_id: any;
  last_card_number: any;
  loose_qty = "0";
  pending_review = [];
  rating_b_details = [];
  driver_rating = [];
  rating_text = [];
  show_select = false;
  show_high_rating = false;
  show_low_rating = false;
  rating_num: any;
  rating_error = false;
  comment_error = false;
  show_highrate_comment = false;
  /*stripe payments */
  stripe_cardid: any;
  stripe_lastCard: any;
  stripe_cardType: any;
  currency: any;
  show_ratecard = false;
  seatingCapacity = true;
  show_dropaddress = false;
  validate_form: any;
  high_rating: any;
  capacity: any;
  length_var: any;
  fare: any;
  dis_fare: any;
  time_fare_est: any;
  x_mileage: any;
  x_min: any;
  helpers = 0;
  vehicle_type_load = false;
  metric_qty: any;
  /* PAYMENT DETAILS VARIABLES*/
  show_payment = false;
  show_cards = false;
  show_cardmethods = true;
  show_wallet = false;
  payment_type = 2;
  config_channel: any;
  showing_balance: any;
  credit_error_msg: any;
  credit_no_book = false;
  credit_line_interval: any;
  soft_limit_error = false;
  hard_limit_error = false;
  show_booklater = false;
  window: any = window;
  AWSService: any = this.window.AWS;
  enableBooknow = false;
  enableBooklater = false;
  dropAddress: any;
  walletEnable = false;
  privacy_policy: any;
  terms_conditions: any;
  specialPickup = false;
  specialPickupType: any;

  pickups = [];
  errvehicles: any;
  errvehicles1: any;
  cardsDetails: any;
  display: any = false;
  numSeats = [];
  interval: any;
  errfare: any;
  isSomeOneElseBooking = 0;
  customerName: any;
  customerNumber: any;
  someoneName: any;
  someoneNum: any;
  bookcancel: Boolean = false;
  locs = [];
  polymarker: any;
  dotmarker = [];
  corporate: Boolean = false;
  cardId: any;
  cardType: any;
  paymentGatewayName: any;
  corporates = [];
  corporatedetails: Boolean = false;
  selectcorporate: Boolean = false;
  corporatemail: any;
  stripekey: any;
  bookingappbuffer: any;
  shipmentlaterbooking: any;
  cardchangeid: any;
  corporateform: Boolean = false;
  corporateerr: any;
  bookingRequestTimeRide: any;
  bookTimeout: any;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$";

  advanceFee: any;
  fareCurrency: any;
  amount: any;
  isSomeoneEnable: any;
  cashEnable: Boolean;
  cardEnable: Boolean;
  bookForSomeoneEnable: Boolean;
  information: any;
  homeImageName = myGlobals.homePageImage;
  FooterImageName = myGlobals.footerLogo;

  constructor(private _dispatcherService: DispatcherService,
    private _loginService: LoginService, fb: FormBuilder,
    private _router: Router,
    private _missionService: MissionService,
    private languageService: LanguageService,
    private _cookie: ConfigService,
    private _haversine: HaversineService,
    private _mqttService: MqttService,
    private _dispatcherHomeService: DispatcherHomeService
  ) {
    // Check for Online or Offline
    this.online$ = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    )

    // mqtt for status change
    _mqttService.missionAnnounced$.subscribe((data: any) => {
      this.notify_bid = data.bookingId;
      this.notify_sid = data.statusText;
      $("#notification_bar").show();
      $('#notification_bar').text(this.increment_num);
      $('#notification_bar').addClass("active");
      $('#notification_ripple').addClass("active");
      $("#no_notify").hide();
      $(".notification_box").append('<div class="notification_class_oncoming" style="text-align: left;font-size: 11px;padding:6px; border: 1px solid #f1ecec;margin-bottom: 2px;"><span>Boooking ID: </span> <span class="notification_booking_id" style="background: #bad6e5;padding: 1px 6px; border-radius: 3px;">' + data.bookingId + '</span><br><span class="notification_status" ><strong> status: </strong>' + data.statusText + '</span><div> ');
      window.setTimeout(() => {
        $('#notification_ripple').removeClass("active");
        $('#notification_bar').removeClass("active");
      }, 5000000);
      switch (data.status) {
        case 6: // Driver on the way
        case 7: // Driver Arrived
        case 8: // Loading start (shipment only)
        case 9: // Journey started
        case 10:  // Reached to Drop start unloading(shipment Only)
        case 11:  // unloaded(shipment Only)
          $(".booking_loader_parent").hide();
          $('#cancel').modal('hide');
          toastr["success"]('Booking Id : ' + data.bookingId + ' <br> Status:' + data.statusText);
          this.increment_num++;
          $(".booking_loader_parent").hide();
          $('#cancel').modal('hide');
          break;
        case 2: // accepted Booking
          toastr["success"]('Booking Id : ' + data.bookingId + ' <br> Status:' + data.statusText);
          this.increment_num++;
          break;
        case 3: // cancel boking before accept by customer
        case 4: // cancel boking after accept by customer
        case 5: // cancel boking by driver
          toastr["warning"]('Booking Id : ' + data.bookingId + ' <br> Status:' + data.statusText);
          $(".booking_loader_parent").hide();
          this.increment_num++;
          break;
        case 13:  // booking expired
          toastr["error"]('Booking Id : ' + data.bid + ' <br> Status:' + data.msg);
          this.increment_num++;
          break;
        case 12:  // Completed
          toastr["success"]('Booking Id : ' + data.bookingId + ' <br> Status:' + data.statusText);
          this.increment_num++;
          break;
      }
    });

    this.form = fb.group({
      'phoneNumber': ['', Validators.compose([Validators.required])],
      'password': ['', Validators.compose([Validators.required, Validators.minLength(4)])]
    });

    this.phoneNumber = this.form.controls['phoneNumber'];
    this.password = this.form.controls['password'];
  }

  public onSubmitLogin(values: Object): void {
    this.submitted = true;

    if (this.form.valid) {
      // your code goes here
    }
  }

  toast_msgs() {

  }
  // newcard: boolean;
  hideSelectcard() {
    $(".card_buttons").removeClass('active');
    $(".add_card_button").addClass('active');
    $("#added_cards_div").hide(500);
    $("#new_cards_div").show(500);
    $('#card-number').focus();
    this.card_number_all = "";
  }
  hideNewcard() {
    $(".card_buttons").removeClass('active');
    $(".select_card_button").addClass('active');
    $("#new_cards_div").hide(500);
    $("#added_cards_div").show(500);
  }

  notification() {
    $("#notification_body").toggle();
    $("#notification_bar").hide();
  }

  // Change Audio Icon
  change_fav_icn() {
    if ($(".mute_on").hasClass('fa-volume-up')) {
      $(".mute_on").removeClass("fa-volume-up");
      $(".mute_on").addClass("fa-volume-off");
      var aud: any = document.getElementById('audio');
      aud.src = "";
    }
    else {
      $(".mute_on").addClass("fa-volume-up");
      $(".mute_on").removeClass("fa-volume-off")
      var aud: any = document.getElementById('audio');
      aud.src = "https://www.soundjay.com/transportation/sounds/car-honk-1.mp3";
    }
  }
  date_success() {
    $(".date_success_change").addClass('has-success');
  }

  delete_photo(id) {                            // delete imaage from array
    $(".ref_img" + id).remove();
    this.file.splice(id - 1, 1);
  }

  imgsrc(fileInput: any, id) {                  // triggers appro input file
    $('#input_upload' + id).trigger("click");
  }
  // Uploads img to appro input file
  uploadImg(fileInput: any, id) {
    var input = fileInput.srcElement;
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e: any) {
        $('#upload' + id).attr("src", e.target.result);
        $(".delete_photo" + id).show();
        $(".show_upload" + id).show();
      }
      reader.readAsDataURL(input.files[0]);
    }
    var compose = fileInput.target.files[0];
    const resizeImage = (settings: { maxSize, file }) => {           // resizesing image function
      const file = settings.file;
      const maxSize = settings.maxSize;
      const reader = new FileReader();
      const image = new Image();
      const canvas = document.createElement('canvas');
      const dataURItoBlob = (dataURI: string) => {
        const bytes = dataURI.split(',')[0].indexOf('base64') >= 0 ?
          atob(dataURI.split(',')[1]) :
          unescape(dataURI.split(',')[1]);
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const max = bytes.length;
        const ia = new Uint8Array(max);
        for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
        return new Blob([ia], { type: mime });
      };
      const resize = () => {
        let width = image.width;
        let height = image.height;

        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }

        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/png');
        return dataURItoBlob(dataUrl);
      };

      return new Promise((ok, no) => {
        if (!file.type.match(/image.*/)) {
          no(new Error(this.booknow.notImage));
          return;
        }

        reader.onload = (readerEvent: any) => {
          image.onload = () => ok(resize());
          image.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
      })
    };
    resizeImage({                                            // resize image call 
      file: compose,
      maxSize: 200
    }).then((resizedImage: any) => {
      function getRandomInt(min, max) {
        return "webcustomer" + Math.floor(Math.random() * (max - min + 1)) + min;      // pushiing to this.file array 
      }
      var img = new File([resizedImage], getRandomInt(1, 10000));
      this.file.push(img)
    }).catch(function (err) {
      console.error(err);
    });
  }

  checkzone_two() {
    $("#map_loader_parent").show();
    this._dispatcherService.zone({
      "lat": this.droplat,
      "long": this.droplong,
    }).subscribe((res) => {
      $("label[for='origin-input3']").remove();
      $("#map_loader_parent").hide();
      $(".loader_place2").hide();
      this.drawroute();
      this.drop_loc_bool = true;
      if (this.pickup_bool && this.drop_bool) {

      }
    });
  }

  // DRAWING ROUTES BASED ON PICKUP AND DROPLATLONGS
  sameasSender() {
    if ($("#sender_input").is(":checked")) {
      var name = sessionStorage.getItem('custname');
      var phone = sessionStorage.getItem('custphn');
      this.rec_name = this.myname;
      this.rec_number = this.myphone;
      this.rec_mail = this.mymail;
    }
    else {
      this.rec_name = "";
      this.rec_number = "";
      this.rec_mail = "";
    }
    setTimeout(() => {
      this.validate_form.element("#receivername,#receivernumber");
      this.validate_form.element("#receivernumber");
    }, 100);
  }

  // Change Quantity
  change_qty(val) {
    if (val == 1) {
      this.change_quantity = true;
      this.loose_qty = "0"
      $("#s-option").trigger('click');
    }
    else {
      this.change_quantity = false;
      this.product_qty = "";
      this.loose_qty = "1"
      $("#f-option").trigger('click');
    }
  }

  // Someone Fields display
  change_bools() {
    this.phone_bool = true;
    let name = $('#someonename').val();
    let phone = $('#someonephone').val();
    if (name != '' && phone != '') {
      this.enableBooknow = true;
      this.enableBooklater = true;
      this.isSomeOneElseBooking = 1;
    }
  }

  changecorporate(val) {
    if (val == 1) {
      this.corporateId = '';
      $("#s-option6").trigger('click');
      this.show_payment = true;
      this.corporatedetails = false;
      $('#corporatedetails').hide();
      $('.card_block').show();
      this.enableBooknow = true;
      this.enableBooklater = true;
    } else if (val == 2) {
      $("#s-option7").trigger('click');
      this.show_payment = false;
      this.corporatedetails = true;
      $('#corporatedetails').show();
      $('.card_block').hide();
      this.payment_type = 3;
      if (this.corporates.length > 0) {
        this.corporateId = this.corporates[0].userId;
        this.enableBooknow = true;
        this.enableBooklater = true;
      } else {
        this.enableBooknow = false;
        this.enableBooklater = false;
      }
      this.getcorporate();
    }
  }

  // Change of Booking Type
  changebooking(val) {
    if (val == 1) {
      $('#someonename').val('');
      $('#someonephone').val('');
      $('#someoneelsepopup').modal('hide');
      $("#s-option4").trigger('click');
      $('#someoneelse').hide();
      this.enableBooknow = true;
      this.enableBooklater = true;
    } else if (val == 2) {
      this.enableBooknow = false;
      this.enableBooklater = false;
      $("#s-option5").trigger('click');
      $('#someoneelse').show();
    }
  }

  // check promo code
  checkPromocode() {
    if ((this.payment_type != this.promoPaymentType && this.promoPaymentType != 3) || (this.walletPay == 1 && this.promoWallet != 1)) {
      if ($('#promocode').val() != '') {
        $('#promocode').val('');
        $('.promocodeParent #err').hide();
        $('.promocodeParent').removeClass('success');
        $('.promocodeParent').removeClass('error');
        alert("promocode is not applicable to this payment type");
      }
    } else {
      if ($('#promocode').val() != '') {
      }
    }
  }

  // Change Payment Type
  change_payment(val) {
    if (val == 1) {                          // cash payment type
      $("#s-option2").trigger('click');
      this.show_cardmethods = false;
      this.credit_no_book = false;
      this.show_cards = false;
      this.payment_type = 2;
      this.walletPay = 0;
      this.checkPromocode();
    } else if (val == 2) {                      // card payment type
      $("#s-option3").trigger('click');
      this.show_cardmethods = true;
      this.show_cards = true;
      this.payment_type = 1;
      this.walletPay = 0;
      this.checkPromocode();
      this.show_default_cards();
    } else {                                  // wallet payment type
      if (this.cardEnable == true && this.cashEnable == true && this.card_number != '') {
        swal({
          title: "Select the payment type",
          text: "Fare may vary after ride. You want pay excess amount via",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: 'Cash',
          cancelButtonText: "Card",
        },
          (isConfirm) => {
            if (isConfirm) {
              this.checkPromocode();
              this.payment_type = 2;
            } else {
              this.checkPromocode();
              if (this.cardsDetails === undefined || this.cardsDetails.cards.length == 0) {
                this.payment_type = 2;
              } else {
                this.payment_type = 1;
              }
            }
          });
      } else if (this.cardsDetails === undefined || this.cardsDetails.cards.length == 0 && this.cashEnable == true) {
        this.payment_type = 1;
      } else {
        this.payment_type = 2;
      }
      $("#s-option1").trigger('click');
      this.show_cardmethods = false;
      this.show_cards = false;
      this.show_wallet = true;
      this.walletPay = 1;
      this.checkPromocode();
    }
  }

  show_cards_wallet(val) {
    var paymentmethods = $('#payment_methods option:selected').val();
    if (paymentmethods == 0) {
      this.show_cards = true;                 // 0 - card show cards wallet
      this.payment_type = 1;
      this.credit_no_book = false;
    }
    else {
      this.creditlimit();
      this.show_cards = false;                 // 1 - credit line hides cards wallet and select payment type as 2
      this.payment_type = 2
    }
  }

  GetCardType(number) {
    this.visa = false;
    this.amex = false;
    this.discover = false;
    this.jcb = false;
    this.diners = false;
    this.master = false;
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null) {
      this.visa = true;
      return "Visa";
    }
    // Mastercard
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null) {
      this.master = true;
      return "Mastercard";
    }
    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null) {
      this.amex = true;
      return "AMEX";
    }
    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null) {
      this.discover = true;
      return "Discover";
    }
    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null) {
      this.diners = true;
      return "Diners";
    }
    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null) {
      this.diners = true;
      return "Diners - Carte Blanche";
    }
    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null) {
      this.jcb = true;
      return "JCB";
    }
    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null) {
      this.visa = true;
      return "Visa Electron";
    }
    return "NOT";
  }

  // Surge API
  route(origin_place_id, destination_place_id, travel_mode,
    directionsService, directionsDisplay) {

    if (!origin_place_id || !destination_place_id) {
      return;
    }
    directionsService.route({
      origin: { 'placeId': origin_place_id },
      destination: { 'placeId': destination_place_id },
      travelMode: travel_mode
    }, (response, status) => {
      if (status === 'OK') {
        var that = this;
        directionsDisplay.setDirections(response);
        this._dispatcherService.surgeprice({
          "ent_wrk_type": localStorage.getItem('vechileType'),
          "ent_pick_lat": this.pickuplat,
          "ent_pick_long": this.pickuplong,
          "ent_drop_lat": this.droplat,
          "ent_drop_long": this.droplong,
        }).subscribe((res) => {
          if (res.errNum == 400) {
            $("#error_popup_parent2").modal('show');
          }
          this.approx = res.ApproxFare;
          this.approx_dist = res.dist;
        });

      } else {
        window.alert(this.booknow.directionreqFail + status);
      }
    });

  }

  // BOOK NOW TIME WILL TAKE NOW TIME USING JAVASCRIPT
  book_now() {
    this.wallet();
    $('#panel1').removeClass('collapse in');
    $('#panel1').addClass('collapse');
    $("#book_now_pop_button").addClass("active");
    $(".flatpickr").val("");
    this.appt_type = 1;
    this.addnew_job();
  }

  bookNowDelivery() {
    $("#book_now_pop_button").addClass("active");
    $(".flatpickr").val("");
    this.appt_type = 1;
    this.addnew_job();
  }

  //CALL APP CONFIG AND SET LATER DATE BASED ON CONFIG TIME
  book_later_trigger() {
    this.appt_type = 2;
    // this.fareEstimate();
    if (this.pickup_bool) {
      if (this.show_dropaddress) {
        if (this.droplat != '' && this.droplat != undefined) {
          if (this.payment_type == 1 && this.card_number == '') {
            swal("WARNING", "Please Add the Card!", "error");
          } else {
            if (this.advanceFee != '') {
              $("#advancefee").modal('show');
            } else {
              this.checkLastDue();
              // $("#booklater_datepicker").modal('show');
            }
          }
        } else {
          $('#drop_address').addClass('has-error');
          $('#origin-input3').focus();
          swal("ERROR", "Drop Address is Mandatory !", "error");
        }
      } else {
        if (this.payment_type == 1 && this.card_number == '') {
          swal("WARNING", "Please Add the Card!", "error");
        } else {
          // $("#advancefee").modal('show');
          if (this.advanceFee != '') {
            $("#advancefee").modal('show');
          } else {
            this.checkLastDue();
            // $("#booklater_datepicker").modal('show');
          }
        }
      }
    } else {
      swal("ERROR", "Pickup Address is Mandatory !", "error");
    }
  }

  bookLaterFunction() {
    if (this.pickup_bool) {
      if (this.show_dropaddress) {
        if (this.droplat != '' && this.droplat != undefined) {
          if (this.payment_type == 1 && this.card_number == '') {
            swal("WARNING", "Please Add the Card!", "error");
          } else {
            if (this.advanceFee > 0) {
              $("#advancefee").modal('show');
            } else {
              $("#booklater_datepicker").modal('show');
            }
          }
        } else {
          $('#drop_address').addClass('has-error');
          $('#origin-input3').focus();
          swal("ERROR", "Drop Address is Mandatory !", "error");
        }
      } else {
        if (this.payment_type == 1 && this.card_number == '') {
          swal("WARNING", "Please Add the Card!", "error");
        } else {
          // $("#advancefee").modal('show');
          if (this.advanceFee > 0) {
            $("#advancefee").modal('show');
          } else {
            $("#booklater_datepicker").modal('show');
          }
        }
      }
    } else {
      swal("ERROR", "Pickup Address is Mandatory !", "error");
    }
  }

  bookingDate: any;
  // Book Later Date Picket
  book_later() {
    var date_later = $(".flatpickr5").val();
    this.bookingDate = moment(date_later).format('YYYY-MM-DD HH:mm:ss');
    if (this.date == "Invalid date") {
      alert("Please select date to continue");
    }
    else {
      $("#booklater_datepicker").modal('hide');
      $("#book_now_pop_button").removeClass("active");
      this.appt_type = 2;
      // this.pricingType = '0';
      this.booknowRideApiCall();
    }
  }

  // Book Later Advance Fee
  bookLaterAdvFee() {
    this.checkLastDue();
    // $("#booklater_datepicker").modal('show');
  }

  bookLaterDelivery() {
    this.appconfig_url();
    $("#booklater_datepicker").modal('show');
  }

  month_year(m, y) {
    var that = this;
    that.card_month = m;
    that.card_year = y;
  }
  clearerror() {
    this.comment_error = false;
  }
  customAlert(x, file_num, callback) {
    this.AWSService.config.accessKeyId = myGlobals.awsid;
    this.AWSService.config.secretAccessKey = myGlobals.awskey;
    var bucket = new this.AWSService.S3({ params: { Bucket: myGlobals.awsbucket } });
    var params = { Body: file_num, Key: file_num.name };
    bucket.upload(params, (err, data) => {
      this.photo[x] = data.Location;
      localStorage.setItem('photo', data.Location);
      callback();
    });

    // do callback when ready

  }
  addphoto() {
    $(".booking_loader_parent").show();
    var x = 0;
    var loopArray = (arr) => {
      this.customAlert(x, arr[x], () => {
        // set x to next item
        x++;
        // any more items in array? continue loop
        if (x < arr.length) {
          loopArray(arr);
        }
        else {
          this.livebooking();
        }
      });
    }
    loopArray(this.file);
  }

  livebooking() {
    if (this.product_qty == undefined) {
      this.product_qty = "";
    }
    $(".booking_loader_parent").show();
    $(".select_cards").removeClass('has-error');
    var devid = sessionStorage.getItem('devid');
    if (this.credit_no_book == true) {
      $(".booking_loader_parent").hide();
      $("#credit_popup_parent").show();
    } else {
      this._dispatcherService.addinfo({
        "ent_dev_id": devid.toString(),
        "ent_wrk_type": this.vehicle_id,
        "ent_appointment_dt": this.booking_time,
        "ent_date_time": this.current_time_var,
        "ent_addr_line1": this.own_lat_long.toString(),
        "ent_lat": this.pickuplat.toString(),
        "ent_long": this.pickuplong.toString(),
        "ent_payment_type": this.payment_type.toString(),
        "ent_zone_drop": this.zone_id_drop,
        "ent_zone_pick": this.zone_id_pick,
        "ent_company": this.company_name,
        "ent_drop_time": this.current_time_var,
        "ent_amount": this.approx.toString(),
        "ent_zoneId_pickup": this.zone_one_id,
        "ent_zoneId_drop": this.zone_two_id,
        "ent_distance": this.approx_dist.toString(),
        "ent_timeFare": this.time_fare,
        "ent_distFare": this.dist_fare,
        "ent_drop_lat": this.droplat.toString(),
        "ent_drop_long": this.droplong.toString(),
        "ent_drop_addr_line1": this.rec_lat_long.toString(),
        "ent_time": this.tme,
        "ent_pas_email": "default",
        "ent_category_id": this.category_id,
        "ent_extra_notes": this.product_det,
        "ent_appt_type": this.appt_type.toString(),
        "ent_category": this.category_name,
        "ent_subcategory": "default",
        "ent_subsubcategory": "default",
        "ent_loadtype": this.loose_qty,
        "ent_cutomer_name": this.rec_name,
        "ent_customer_phone": this.rec_number,
        "ent_specialities": "default",
        "ent_ZoneType": "default",
        "ent_card_id": this.card_number,
        "lastCard": this.stripe_lastCard,
        "cardType": this.stripe_cardType,
        "helpers": this.helpers,
        "appliedAmount": this.applied_amt,
        "estimateId": this.estimate_id,
        "pricingType": this.pricingType,
        "shipemnt_details": [
          {
            "ent_dist": this.dist,
            "quantity": this.product_qty,
            "product_name": "",
            "ent_loadtype": this.loose_qty,
            "ent_drop_time": this.current_time_var,
            "ent_receiver_address": this.rec_lat_long,
            "ent_receiver_mobile": this.rec_number,
            "ent_receiver_name": this.rec_name,
            "ent_receiver_landmark": "",
            "ent_drop_long": this.droplong.toString(),
            "photo": this.photo,
            "passanger_chn": 2,
            "additional_info": this.product_det,
            "ent_receiver_email": this.rec_mail,
            "ent_drop_lat": this.droplat.toString(),
            "weight": this.product_wgt,
            "ent_Approxcost": this.approx,
            "goodsType": "",
            "pricingType": this.pricingType,
          }
        ]
      }).subscribe((res) => {
        $(".booking_loader_parent").hide();
        if (res.errFlag == 0) {
          $("#myModal").modal('hide');
          swal(this.booknow.bookingcnf, this.booknow.thanksBooking, this.booknow.success)
          setTimeout(function () {
            $("#hidden_btn").trigger('click');
            $("#tasks_refresh").trigger('click');
          }, 300);
        }
        else {
          alert(res.errMsg);
        }
      });
    }
  }

  addhigh_reviews(text) {
    $("#cb10").attr('checked', false);
    this.show_highrate_comment = false;
    if (this.high_rating == undefined || this.high_rating == "") {
      this.high_rating = text;
    }
    else {
      if (this.high_rating.indexOf(text) < 0)
        this.high_rating = this.high_rating + "," + text
    }
  }

  show_comment() {
    this.high_rating = "";
    $("#high_rating_box input").attr('checked', false);
    this.show_highrate_comment ? this.show_highrate_comment = false : this.show_highrate_comment = true;
  }

  select_card(itemid) {
    $(".check_id" + itemid).prop('checked', true);
    $('input.check_id' + itemid).attr('checked', true);
  }

  getallzones() {
    $("#inputTextToSave").empty();
    this._dispatcherService.allzones({
      "token": localStorage.getItem('devtoken'),
    }).subscribe((res) => {
      this.vechiletypes = res.data.typesData;
      for (var key in res.data) {
        $("#inputTextToSave").append("<textarea>" + res.data[key].Name + "---" + res.data[key].id + "</textarea>" + ",");
      }
    });
  }

  payment_details(appconfig_val) {
    this._dispatcherService.payment({
    }).subscribe((res) => {
      if (res.errFlag == 0) {
        if (res.data.paidByReceiver == true && appconfig_val == true) {
          this.show_payment = true;
        }
        else {
          this.show_payment = false;
          this.show_cards = true;
        }

        if (res.data.enableWallet == false) {             // enable wallet 
          if (this.payment_type == 0 && this.payment_type != undefined) {
            this.show_wallet = false;
          } else {
            this.show_wallet = false;
            this.show_cards = true;
            this.payment_type = 1;
          }
          sessionStorage.setItem('wallet', "1");
        }
        else {
          this.show_wallet = true;
          sessionStorage.setItem('wallet', "0");
        }
      }
    })
  }

  currentlat() {
    this.information = JSON.parse(sessionStorage.getItem('ipinformation'));
    this.current_lat = this.information.latitude;
    this.current_lng = this.information.longitude;
    this.authorize_call = setInterval(() => {
    }, 5000);
  }

  open_selectbox() {
    this.show_select = true;
  }

  saveTextAsFile() {
    var textToSave = $("#inputTextToSave").text();
    textToSave = textToSave.replace(/,/g, "\n");
    textToSave = textToSave.replace(/\n/g, "\r\n");
    var textToSaveAsBlob = new Blob([textToSave], { type: "text/plain" });
    var textToSaveAsURL = window.URL.createObjectURL(textToSaveAsBlob);
    var fileNameToSaveAs = "zones";

    var downloadLink = document.createElement("a");
    downloadLink.download = fileNameToSaveAs;
    downloadLink.innerHTML = "Download File";
    downloadLink.href = textToSaveAsURL;
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);

    downloadLink.click();
  }

  destroyClickedElement(event) {
    document.body.removeChild(event.target);
  }
  logged_out() {
    this._router.navigate(['login']);
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  passDetails(i: number) {
    var that = this;
    this.passDetailsContent = this.data[i];
    this.dynamic_latlong = this.passDetailsContent.shipment_details[0].address;
  }

  gethelpers() {
    alert("");
  }

  close_bulk() {
    $("#file_input").val("");
  }
  show_card() {
    if (this.show_add_card) { this.show_add_card = false } else { this.show_add_card = true; }
  }

  dcard(cardid) {
    $(".check_id" + cardid).prop('checked', true);
    if (cardid == undefined) {
      alert("please select a card");
    }
    else {
      $(".loader_cardadd_parent").show();
      this.deleteCard(cardid);
      this.card_number = '';
    }
  }
  usecard() {
    this.show_default_cards();
    var cardid = $("input[name=card_select]:checked").val();
    this.last_card_number = $(".last_digits" + cardid).text();
    if (cardid == undefined) {
      alert("please select a card");
    }
    else {
      this.card_number = $("input[name=card_select]:checked").val();
      for (var inst = 0; inst < this.allcards.length; inst++) {
        if (this.allcards[inst].id == this.card_number) {
          this.stripe_lastCard = this.allcards[inst].last4;
          this.stripe_cardType = this.allcards[inst].funding;
          break;
        }
      }
      $(".card_block").removeClass('has-error');
      $(".card_block").addClass('has-success');
      $("#credit_card_popup").modal('hide');
    }
  }

  onChange(event) {
    var event_file = event;
    var file_name = $("#file_input").val();
    file_name = file_name.replace(/[{()}]/g, '');
    var regex = /^([a-zA-Z0-9\s_\\.:])+(.csv|.txt|.xlsx)$/;
    if (regex.test(file_name.toLowerCase())) {
      if (typeof (FileReader) != "undefined") {
        var reader = new FileReader();
        reader.onload = (e) => {

          let file = event_file.srcElement.files;
          let postData = { ent_sess_token: localStorage.getItem('authToken'), ent_dev_id: localStorage.getItem('devid') }; // Put your form data variable. This is only example.

          $("#file_input").val('');
          $("#bulk_close_btn").trigger('click');

        }
        reader.readAsText($("#file_input")[0].files[0]);
      } else {
        alert("This browser does not support HTML5.");
      }

    } else {
      alert(this.booknow.validCsv);
      $("#file_input").val("");
      $("#file_input").focus();
    }
  }

  // Verify Mail
  check_mail() {
    this._loginService.verifymail({
      validationType: "1",
      ent_email: this.signup_mail,
    }).subscribe((res) => {
      if (res.errFlag == 0) {
        $('.email_validation').addClass('has-success');
        $('.email_validation').removeClass('has-error');
        $(".loader_email").hide();
        this.mail_bool = true;
      }
      else {
        $('.email_validation').removeClass('has-success');
        $('.email_validation').addClass('has-error');
        $("label[for='email']").text(this.booknow.emailRgd);
        $(".loader_email").hide();
        this.mail_bool = false;
      }
    });
  }

  // Verify Phone
  check_phone() {
    this._loginService.verifymail({
      validationType: "2",
      mobile: this.signup_number,
    }).subscribe((res) => {
      $('.phone_validation').addClass('has-success');
      $('.phone_validation').removeClass('has-error');
      $(".loader_phone").hide();
      this.phone_bool = true;
    });
  }

  clear_all_vehicles() {
    this.duration = [];
    this.approx_dist_txt = [];
    this.approx = [];
  }

  // Pending Reviews
  pending_reviews() {
    this._dispatcherService.pendingRef({
    }).subscribe((res) => {
      if (res.data.length > 0) {
        this.pending_review = res.data;
      }
    });
  }
  // Submit Reviews
  submitReivew() {               // submit review 
    if (this.rating_num == '' || this.rating_num == undefined) {
      this.rating_error = true;                               // rating error show
    }
    else {
      if (this.rating_num < 4) {                                  // below 4 star rating check all review, rating and comment fileds
        if ($("#review_content").val() == '') {
          this.comment_error = true;
        }
        else {
          var comment = $("#review_content").val();
          var review = $('input[name=low_rating]:checked').val();
          this.submitreview_call(comment, review)
        }
      }
      else {
        var selected_review = false;
        var comment = $("#review_content").val();
        if (this.high_rating != "" && this.high_rating != undefined) {
          selected_review = true;
        }
        else if (this.show_highrate_comment == true && comment != '') {
          this.high_rating = "other";
          selected_review = true;
        }

        if (selected_review == true)
          this.submitreview_call(comment, this.high_rating)
        else
          alert("select a review");
      }
    }
  }
  // Submit Review API
  submitreview_call(comment, review) {
    $(".booking_loader_parent").show();
    var bid = this.rating_b_details["bid"];
    this._dispatcherService.submitereivew({
      "id": bid.toString(),
      "rating": this.rating_num,
      "review": review,
      "comment": comment,
    }).subscribe((res) => {
      $("#review_popup").modal('hide');
      $(".booking_loader_parent").hide();
      if (this.pending_review.length > 0) {
        for (var inst = 0; inst < this.pending_review.length; inst++) {
          var bid = this.rating_b_details["bid"];
          if (this.pending_review[inst].order_id == bid) {
            this.pending_review.splice(inst, 1);
            this.show_select = false;
            this.show_high_rating = false;
            this.show_low_rating = false;
            this.rating_num = false;
            this.rating_error = false;
            this.comment_error = false;
            $("input[name=rating]").prop('checked', false);
            this.callpendingreivews(1);
            break;
          }
        }
      }
    });
  }
  callpendingreivews(value) {
    if (value == 1) {
    }
    else {
      if (this.pending_review.length > 0) {
        $("#review_popup").modal('show');
      }
    }
  }
  show_raing_txt(rate) {
    this.show_highrate_comment = false;
    this.high_rating = "";
    this.rating_num = rate;
    this.show_select = false;
    this.rating_error = false;  // hide error if any
    if (rate < 4) {
      $("input[name=selector_review]").val($("input[name=selector_review] option:first").val());
      this.rating_text = [];
      this.show_low_rating = true;
      this.show_high_rating = false;
      for (var key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    }
    else {
      this.rating_text = [];
      this.show_low_rating = false;
      this.show_high_rating = true;
      this.show_select = true;
      for (var key in this.driver_rating) {
        if (key == rate) {
          this.rating_text = this.driver_rating[key];
          break;
        }
      }
    }
  }

  websitelink: any;
  fblink: any;
  twitterlink: any;
  linkedinlink: any;
  linkName: any;
  linkYear: any;
  uberforalllink: any;
  ngOnInit() {
    this.websitelink = myGlobals.websitelink;
    this.fblink = myGlobals.fblink;
    this.twitterlink = myGlobals.twitterlink;
    this.linkedinlink = myGlobals.linkedinlink;
    this.linkName = myGlobals.linkName;
    this.linkYear = myGlobals.year;
    this.uberforalllink = myGlobals.uberforalllink;
    this.latlong();
    $('.promocodeParent button').attr('disabled', 'disabled');
    $(".booking_loader_parent").show();
    setTimeout(() => {
      $(".booking_loader_parent").hide();
    }, 1000);

    this.wallet();
    this.show_wallet = true;

    $('#myModal').on('hidden.bs.modal', function () {
      $(this).find('form').trigger('reset');
    })

    $('#accordion').on('mouseleave', function () {
    });

    $('#panel1').on('show.bs.collapse hidden.bs.collapse', function () {
      $(this).prev().find('.glyphicon').toggleClass('glyphicon-plus glyphicon-minus');
    })

    $('.gender').on('change', function () {
      $('.gender').not(this).prop('checked', false);
    });

    $('.wheelChair').on('change', function () {
      $('.wheelChair').not(this).prop('checked', false);
    });

    $('.booster_seat').on('change', function () {
      $('.booster_seat').not(this).prop('checked', false);
    });

    $('.extra_bag').on('change', function () {
      $('.extra_bag').not(this).prop('checked', false);
    });

    $('.quite_ride').on('change', function () {
      $('.quite_ride').not(this).prop('checked', false);
    });

    $('.bike_carrier').on('change', function () {
      $('.bike_carrier').not(this).prop('checked', false);
    });

    // Toaseter
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-left",
      "preventDuplicates": true,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "8000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    this.disphome = this.languageService.dispatcherhome;
    this.booknow = this.languageService.book_now;
    this.addcard = this.languageService.add_card;
    this.booklater = this.languageService.book_later;
    this.bookcomplete = this.languageService.bookingComplete;
    this.invoice = this.languageService.invoice;
    this.langtask = this.languageService.tasks;
    this.privacy_policy = myGlobals.privacy_policy;
    this.terms_conditions = myGlobals.terms_conditin;

    this.directionsDisplay = new google.maps.DirectionsRenderer({          // google path no default markers 
      suppressMarkers: true,
      polylineOptions: { strokeColor: "#34c10d" }
    });

    $('[data-toggle="tooltip"]').tooltip();
    $("#someonephone").intlTelInput({
      autoHideDialCode: true,
      geoIpLookup: function (callback) {
        this.information = JSON.parse(sessionStorage.getItem('ipinformation'));
        var countryCode = (this.information && this.information.country) ? this.information.country : "";
        callback(countryCode);
      }, initialCountry: "auto",
      nationalMode: false,
      separateDialCode: true,
      utilsScript: "assets/js/utils.js"
    });

    $('#credit_form_validation').validate({
      rules: {
        username: {
          minlength: 3,
          required: true
        },
        month: {
          required: true
        },
        card_name: {
          required: true
        },
        cvv: {
          minlength: 3,
          required: true
        },
      },
      success: (element) => {

      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error')
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
      },
      submitHandler: (form) => {
        this.stripe_cardadd();
      }
    });
    var telInput = $("#someonephone"),
      errorMsg = $("#error-msg"),
      validMsg = $("#valid-msg");
    var reset = function () {
      telInput.removeClass("error");
      errorMsg.addClass("hide");
      validMsg.addClass("hide");
    };
    telInput.blur(function () {
      reset();
      if ($.trim(telInput.val())) {
        if (telInput.intlTelInput("isValidNumber")) {
          validMsg.removeClass("hide");
        } else {
          telInput.addClass("error");
          errorMsg.removeClass("hide");
        }
      }
    });

    // Phone Validation
    $('#someonephone').keypress(function (event) {
      var $this = $(this);
      if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which != 0 && event.which != 8))) {
        event.preventDefault();
      }

      var text = $(this).val();
      if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
        event.preventDefault();
      }
    })

    $.validator.addMethod(
      "uniqueUserName",
      function (value, element) {
        if (telInput.intlTelInput("isValidNumber")) {
          return true;
        } else {
          return false;
        }
      },
      "Please enter valid number"
    );

    $('.module input').keyup(function (e) {
      var code = e.keyCode || e.which;
      if ($(this).val().length > 0) {
        if ($(this).attr('id') === '4') {
          $('.one').css({ 'box-shadow': '0 0 10px #1EB2F7' });
          $('.one').css({ 'box-shadow': 'none' });
          $(this).blur();
          $(".send").removeClass('send_animate');
          $(".send").addClass('signup_inst');
        }
        if (code !== 4) {
          $(this).focusNextInputField();
        }
      } else {
        $(".send").addClass('send_animate');
        $(".send").removeClass('signup_inst');
        if ($(this).attr('id') !== '1') {
          $(this).focusPrevInputField();
        }
      }
    });

    $.fn.focusNextInputField = function () {
      return this.each(function () {
        var fields = $(this).parents('form:eq(0),body').find('button,input,textarea,select');
        var index = fields.index(this);
        if (index > -1 && (index + 1) < fields.length) {
          fields.eq(index + 1).focus();
        }
        return false;
      });
    };

    $.fn.focusPrevInputField = function () {
      return this.each(function () {
        var fields = $(this).parents('form:eq(0),body').find('button,input,textarea,select');
        var index = fields.index(this);
        if (index > -1 && (index - 1) < fields.length) {
          fields.eq(index - 1).focus();
        }
        return false;
      });
    };

    $('.send_animate').click(function () {
      $('.send_animate').animate({ left: "-15px" }, 100).animate({ left: "15px" }, 100).animate({ left: "0px" }, 100);
    });

    this.appconfig_url();             // app config api calling function 
    $('.input-cart-number').on('keyup change', ($event) => {
      $(".card_error_msg").remove();

      var card_number = '';
      $('.input-cart-number').each(function () {
        card_number += $(this).val() + ' ';
        if ($(this).val().length == 4) {
          let attrb = parseInt($(this).attr('data-attribute'));
          attrb++;
          $("#card-number-" + attrb).focus();
        }
      })
      this.card_number_all = card_number.replace(/ /g, '');
      this.GetCardType(this.card_number_all);
      $('.credit-card-box .number').html(card_number);
    });

    $('#card-holder').on('keyup change', function ($event) {
      $('.credit-card-box .card-holder div').html($event.target.value);
    });


    $('#card-expiration-month, #card-expiration-year').change(($event) => {
      $(".month_error_msg").remove();
      var m, y;
      m = $('#card-expiration-month option:selected').val();
      var y = $('#card-expiration-year').val();
      if (y != null) {
        y = $('#card-expiration-year').val();
      }
      else {
        y = '';
      }
      $('.card-expiration-date div').html(m + '/' + y);
      var that = this;
      that.month_year(m, y);
    });

    $('#card-ccv').on('focus', ($event) => {
      $('.credit-card-box').addClass('hover');
    }).on('blur', function () {
      $('.credit-card-box').removeClass('hover');
    }).on('keyup change', ($event) => {
      $('.ccv div').html($event.target.value);
      this.card_cvc = $event.target.value
    });


    /*--------------------
    CodePen Tile Preview
    --------------------*/
    setTimeout(function () {
      $('#card-ccv').focus().delay(1000).queue(function () {
        $(this).blur().dequeue();
      });
    }, 500);

    $(".csv_file_upload").change(function () {
      var regex = /^([a-zA-Z0-9\s_\\.:])+(.csv|.txt)$/;
      if (regex.test($(".csv_file_upload").val().toLowerCase())) {
        if (typeof (FileReader) != "undefined") {
          var reader = new FileReader();
          reader.onload = (e: any) => {
            var table = $("<table />");
            var rows = e.target.result.split("\n");
            for (var i = 1; i < rows.length; i++) {
              var row = $("<tr />");
              var cells = rows[i].split(",");
              for (var j = 1; j < cells.length; j++) {
                var cell = $("<td />");
                cell.html(cells[j]);
                row.append(cell);
              }
              table.append(row);
            }
          }
          reader.readAsText($(".csv_file_upload")[0].files[0]);
        } else {
          alert("This browser does not support HTML5.");
        }
      } else {
        alert(this.booknow.validCsv);
        $(".csv_file_upload").val("");
        $(".csv_file_upload").focus();
      }
    });

    this.current_time = new Date();
    this.current_time_var = moment().format('YYYY-MM-DD HH:mm:ss');

    // custom file input
    ; (function (document, window, index) {
      var inputs = document.querySelectorAll('.inputfile');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        input.addEventListener('change', function (e) {
          var fileName = '';
          if (this.files && this.files.length > 1)
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
          else
            fileName = e.target.value.split('\\').pop();
          if (fileName) {
            label.querySelector('span').innerHTML = fileName;
            $('#choose_file_span').text(fileName);
          }
          else
            label.innerHTML = labelVal;
        });
        // Firefox bug fix
        input.addEventListener('focus', function () { input.classList.add('has-focus'); });
        input.addEventListener('blur', function () { input.classList.remove('has-focus'); });
      });
    }(document, window, 0));

    (function (e, t, n) { var r = e.querySelectorAll("html")[0]; r.className = r.className.replace(/(^|\s)no-js(\s|$)/, "$1js$2") })(document, window, 0);

    // end of custom file input

    $('#addnew_but').click(() => {
      this.addnew_job();
    });
    var placeSearch, autocomplete;
    autocomplete = new google.maps.places.Autocomplete(
      (document.getElementById('pac-input2')),
      { types: ['geocode'] });

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.

    $('.fullscreen_icn').on('click', event => {
      screenfull.toggle();
      $('.fullscreen_icn').toggleClass('glyphicon-fullscreen');
      $('.fullscreen_icn').toggleClass('glyphicon-resize-small');
    });

    $(document).click(function (e) {
      if ($(e.target).is('#notification_body,#notification_body *')) {
        return;
      }
      else {
        $("#notification_body").hide();
      }
    });

    this.fname_b = localStorage.getItem('fname');
    this.fmail_b = localStorage.getItem('emailId')
    this.validate_form = $('#form2').validate({
      rules: {
        username: {
          minlength: 3,
          required: true
        },
        phonenumber: {
          minlength: 3,
          required: true
        },
        email: {
          email: true,
          required: true
        },
        time: {
          required: true,
        },
        weight: {
          minlength: 1,
          required: true,
        },
        date: {
          required: true,
        },
        quantity: {
          minlength: 1,
          required: true,
        },
        receivername: {
          minlength: 3,
          required: true
        },
        receiverphonenumber: {
          maxlength: 20,
          required: true
        },
        receiveremail: {
          email: true,
          required: true
        },
        password: {
          minlength: 5,
          required: true
        },
        payment: {
          required: true
        },
        pickuplocation: {
          // findlocation: true,
          required: true,

        },
        receiveraddress: {
          // finddroplocation: true,
          // required: true,
        }
      },
      highlight: function (element) {
        $(element).closest('.form-group').removeClass('has-success').addClass('has-error');
      },
      unhighlight: function (element) {
        $(element).closest('.form-group').removeClass('has-error').addClass('has-success');
      },
      submitHandler: (form) => {
        this.addinfo();
      }
    });

    $.validator.addMethod(
      "findlocation",
      (value, element) => {
        if (this.pickup_loc_bool && this.pickup_bool) {
          return true;
        } else {
          return false;
        }
      },
      this.disphome.validLoc
    );

    $(".vehicletypes_but").on('click', 'li', function () {
      $("#popup_dropdown:first-child").text($(this).text());
      $("#popup_dropdown:first-child").val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });

    $('#wght_value,.input-cart-number,#card-ccv').keypress(function (event) {
      var $this = $(this);
      if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which != 0 && event.which != 8))) {
        event.preventDefault();
      }

      var text = $(this).val();
      if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
        event.preventDefault();
      }
    });

    $("#add_popup_but").click(() => {
    });

    jQuery('#book_now_pop_button').trigger('click');

    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });

    var map;

    jQuery('#book_now_pop_button').click(function () {
      $("this").addClass('active');
    });

    jQuery('#right_front_div').hide();

    jQuery('.front_div_close').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').hide();
    });

    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });
    jQuery('.connections_div').click(function () {
      jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').show();
    });

    $('.styled-select select').change(() => {
      this.category_id = $('.styled-select select option:selected').val();
      this.category_name = $('.styled-select select option:selected').text();
    });

    $('.styled-select2 select').change(() => {
      this.helpers = $('.styled-select2 select option:selected').val();
    });
    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but').find('span').toggleClass("active");
    });

    $('#assigned_but').click(() => {
      $("#left_full_body").hide();
      this.passDetailsContent = [];
    });
    $('#un_assigned_but').click(() => {
      $("#left_full_body").show();
      this.passDetailsContent = [];
    });
    $('#completed_but').click(() => {
      $("#left_full_body").hide();
      this.passDetailsContent = [];
    });
    $("#origin-input2").change(() => {
      clearInterval(this.vehicles_interval);
      this.pickup_loc_bool = false;
      this.clear_all_vehicles();
    });
    $("#origin-input3").change(() => {
      clearInterval(this.vehicles_interval);
      this.drop_loc_bool = false;
      this.clear_all_vehicles();
    });
    jQuery(".width_3").click(function () {
      jQuery(".width_3").removeClass("active");
      jQuery(this).addClass("active");
    });
    jQuery(".width_3_rt").click(function () {
      jQuery(".width_3_rt").removeClass("active");
      jQuery(this).addClass("active");
    });
    jQuery(".mute_onn").click(function () {
    });

    $("#noservice_ok_but,#noservice_ok_but2").click(() => {
      this.show_error_bool = false;
      $("#error_popup_parent,#credit_popup_parent").hide();
      $("#error_popup_parent2").hide();
    });
    $("#noti").click(() => {
      this.increment_num = 1;
      $("#notification_bar").hide();
      $("#notification_ripple").hide();
    });
    $('#myModal').on('hidden.bs.modal', () => {
      clearInterval(this.credit_line_interval);
      $("#origin-input2").val("");
      $(".form-group.has-feedback").removeClass('has-success');
      $("#origin-input3").val("");
      $(".form-group.has-feedback").removeClass('has-success');
      $(".remove_details input,textarea").val("");
      this.zone_one_title = " ";
      this.zone_two_title = " ";
      $("#est_journey").text("");
      $("#choose_file_span").text("");
      this.date = "";
      this.time = "";
      this.pricingType = "";
      this.pickuplong = "";
      this.pickuplat = "";
      this.own_lat_long = "";
      this.enableBooknow = false;
      this.enableBooklater = false;
      this.numSeats = [];
      this.show_cards = false;
      this.approx = "";
      this.approx_dist_txt = "";
      this.card_number = '';
      this.droplat = "";
      this.droplong = "";

      this.own_drop_latlong = '',
        this.own_lat_long = '',


        this.rec_name = "";
      this.rec_number = "";
      this.payment_type = 2;
      this.show_ratecard = false;
      this.show_dropaddress = false;
      this.vehicle_types = [];
      clearInterval(this.vehicles_interval);
      $("#sender_input").attr('checked', false);
      $("#loader_place2").hide();
      $(".form-group").removeClass('has-error');
      $(".form-group").removeClass('has-success');
      $("label.error").remove();
      $(".multiple_img").hide();
      $(".ref_img1").show();
      $(".delete_photo_icn").hide();
      $("#upload1,#upload2,#upload3,#upload4,#upload5").attr('src', './assets/img/image_upload.png');
      this.file = [];
      $("select[name=goodstype]").val($("select[name=goodstype] option:first").val());
      $("select[name=helpers]").val($("select[name=helpers] option:first").val());
      $("select[name=payment_method]").val($("select[name=payment_method] option:first").val());
      $("#f-option2").trigger('click');
      this.seatingCapacity = true;
      this.seats = 1;
      // this.gender = 0;
      this.specialPickup = false;
      this.isSomeOneElseBooking = 0;
      $('#someoneelse').hide();
      this.corporate = false;
      $('#corporatedetails').hide();
      this.corporatedetails = false;

      this.cardId = "";
      this.cardType = "";
      this.paymentGatewayName = "";
      this.distFare = "";
      this.distance = "";
      this.timeFare = "";
      this.duration = "";
      this.errvehicles1 = '';

      this.show_payment = false;
      this.cashEnable = false;
      this.cardEnable = false;
      this.walletenabled = false;

      $('#corporatedetails #err').hide();
      $('#bookNowTab #err').hide();
      this.corporateId = '';
      $("#s-option6").trigger('click');

      this.checkedDriverpref = [];
      this.prefPrice = 0;
      this.addpref = true;
      this.enablepreferences = false;
      //card triggers
    });
    // This example requires the Places library. Include the libraries=places
    // parameter when you first load the API. For example:
    // <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
  }

  checkedDriverpref = [];
  prefPrice = 0;
  addpref = true;
  enablepreferences = false;
  setMapOnAll(map) {
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
    this.markers.length = 0;
  }

  getvehicles() {
    this.current_time = new Date();
    flatpickr(".flatpickr", {
      defaultDate: 1477697199863, // Date objects and date strings are also accepted
      enableTime: true,
      minDate: this.current_time_var, // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2017-03-01",
    });
    flatpickr(".flatpickr2", {
      defaultDate: 1477697199863, // Date objects and date strings are also accepted
      enableTime: false,
      minDate: new Date(), // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2018-12-20",
      altFormat: "M j, Y"
    });
    flatpickr(".flatpickr3", {
      defaultDate: 1477697199863, // Date objects and date strings are also accepted
      enableTime: true,
      enableSeconds: true,
      minDate: this.current_time.getFullYear() + '-' + ("0" + (this.current_time.getMonth() + 1)).slice(-2) + '-' + (this.current_time.getDate()) + " " + (this.current_time.getHours() + 2) + ":" + this.current_time.getMinutes() + ":" + this.current_time.getSeconds(), // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2018-12-20",
      altFormat: "M j, Y"
    });
  }

  // UBER FOR ALL NEW DISPATCHER CODE

  onpickupmethod() {
    $("#origin-input2").closest('.form-group').removeClass('has-error').removeClass('has-success');
    if ($('#origin-input2').val() == '') {
      $("#origin-input2").closest('.form-group').addClass('has-error').removeClass('has-success');
      if (this.pickup_marker_loc != undefined) {
        this.directionsDisplay.setMap(null);
        this.pickup_marker_loc.setMap(null);
      }
    }
  }

  ondropmethod() {
    $("#origin-input3").closest('.form-group').addClass('has-success');
    if ($('#origin-input3').val() == '') {
      $("#origin-input3").closest('.form-group').removeClass('has-error').removeClass('has-success');
      if (this.drop_marker_loc != undefined) {
        this.drop_marker_loc.setMap(null);
        this.directionsDisplay.setMap(null);
      }
    }
    $('#origin-input2').attr('value', '');
    this.drop_loc_bool = false;
  }

  currentlat_new() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(data => {
        console.log(data);
        this.current_lat = data.coords.latitude;
        this.current_lng = data.coords.longitude;
      });
    } else {
      jQuery.get('https://ipapi.co/json/').always((res) => {
        if (res.status >= 400 || res.error) {
          jQuery.get('https://ipinfo.io', (response) => {
            this.current_lat = (response.loc).split(',')[0];
            this.current_lng = (response.loc).split(',')[1];
          }, 'jsonp');
        } else {
          this.current_lat = res.latitude;
          this.current_lng = res.longitude;
        }
      });
    }                     // get current lat long using ipinfo
  }
  // Add Pickup & Drop Autocomplete
  addnew_job() {
    this.currentlat_new();
    setTimeout(() => {
      this.map_variable++;
      $(".popup_left_div").animate({ scrollTop: 0 }, 100);
      var popup_ht = $('.popup_left_div').height();
      $('.popup_right_div').css('height', popup_ht);
      this.appconfig_url();
      this.paymentDetails();
      var style = [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 13
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#144b53"
            },
            {
              "lightness": 14
            },
            {
              "weight": 1.4
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#08304b"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#0c4152"
            },
            {
              "lightness": 5
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#0b434f"
            },
            {
              "lightness": 25
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#0b3d51"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "color": "#146474"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#021019"
            }
          ]
        }
      ];

      var origin_place_id = null;
      var destination_place_id = null;
      var travel_mode = 'WALKING';
      var map = new google.maps.Map(document.getElementById('map2'), {
        mapTypeControl: false,
        center: { lat: 43.0828, lng: -79.0742 },
        zoom: 13
      });
      this.map = map;
      map.setOptions({
        styles: style,
        minZoom: 2, maxZoom: 20
      });

      var directionsService = new google.maps.DirectionsService;
      var directionsDisplay = new google.maps.DirectionsRenderer({
        suppressMarkers: true
      });
      directionsDisplay.setMap(map);

      // destination autocomplete
      var destination_input = document.getElementById('origin-input3');
      var destination_autocomplete = new google.maps.places.Autocomplete(destination_input);
      destination_autocomplete.bindTo('bounds', this.map);

      var origin_input = document.getElementById('origin-input2');
      var modes = document.getElementById('mode-selector');

      map.controls[google.maps.ControlPosition.TOP_LEFT].push();
      map.controls[google.maps.ControlPosition.TOP_LEFT].push();
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(modes);

      var origin_autocomplete = new google.maps.places.Autocomplete(origin_input);
      origin_autocomplete.bindTo('bounds', map);

      // Sets a listener on a radio button to change the filter type on Places
      // Autocomplete

      function expandViewportToFitPlace(map, place) {
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }
      }

      if (origin_autocomplete) {
        origin_autocomplete.addListener('place_changed', () => {
          this.vehicle_type_load = true;
          var place = origin_autocomplete.getPlace();
          origin_place_id = place.place_id;
          this.pickuplat = place.geometry.location.lat();
          this.pickuplong = place.geometry.location.lng();
          // $("#s-option2").trigger('click');
          setTimeout(() => {
            this.someoneelseRange();
          }, 300);
          this.getvechicles();
          this.vehicle_types = [];
          this.vehicles_empty = false;
          this.current_lat = place.geometry.location.lat();
          this.current_lng = place.geometry.location.lng();
          $(".loader_place1").hide();
          $("#origin-input2").closest('.form-group').removeClass('has-error').addClass('has-success');
          $("label[for='origin-input3']").remove();
          this.pickup_bool = true;
          this.show_error_bool = true;
          this.checking_vehs = true;
          this.own_lat_long = place.formatted_address;
          origin_autocomplete.bindTo('bounds', map);
          var pos = new google.maps.LatLng(this.pickuplat, this.pickuplong);
          if (this.pickup_marker_loc != undefined && this.drop_marker_loc != undefined) {
            this.pickup_marker_loc.setMap(null);
            this.directionsDisplay.setMap(null);
          }
          if (this.specialpickupmarker != undefined && this.dotmarker != undefined && this.polymarker != undefined && this.pickup_marker_loc != undefined) {
            this.pickup_marker_loc.setMap(null);
            this.specialpickupmarker.setMap(null);
            this.directionsDisplay.setMap(null);
            for (let i = 0; i < this.dotmarker.length; i++) {
              this.dotmarker[i].setMap(null);
            }
            this.dotmarker = [];
            this.locs = [];
            this.polymarker.setMap(null);
          }
          this.pickup_marker_loc = new google.maps.Marker({
            position: pos,
            icon: myGlobals.pickupicn,
            map: this.map,
            draggable: true
          });
          google.maps.event.addListener(
            this.pickup_marker_loc,
            'dragend',
            () => {
              this.pickuplat = this.pickup_marker_loc.position.lat();
              this.pickuplong = this.pickup_marker_loc.position.lng();
              this.checkpickup();
            }
          );

          if (this.droplat != '' && this.droplat != undefined) {
            this.drawroute();
          }

          this.mappickup_drop_bounds = new google.maps.LatLngBounds();
          this.mappickup_drop_bounds.extend(this.pickup_marker_loc.getPosition());
          this.map.fitBounds(this.mappickup_drop_bounds);
          this.map.setZoom(13);
          if (this.pickup_bool && this.drop_bool) {
            this.vehicle_type_load = true;
          }
        });
      }

      if (destination_autocomplete) {
        destination_autocomplete.addListener('place_changed', () => {
          var place = destination_autocomplete.getPlace();
          destination_place_id = place.place_id;
          this.droplat = place.geometry.location.lat();
          this.droplong = place.geometry.location.lng();
          this.own_drop_latlong = place.formatted_address;
          destination_autocomplete.bindTo('bounds', map);
          this.drop_bool = true;

          var pos = new google.maps.LatLng(this.droplat, this.droplong);
          if (this.drop_marker_loc != undefined) {
            this.drop_marker_loc.setMap(null);
            this.directionsDisplay.setMap(null);
          }
          this.drawroute();
          this.drop_loc_bool = true;
          this.drop_marker_loc = new google.maps.Marker({
            position: pos,
            icon: myGlobals.dropupicn,
            map: this.map,
            draggable: true
          });
          google.maps.event.addListener(
            this.drop_marker_loc,
            'dragend',
            () => {
              this.droplat = this.drop_marker_loc.position.lat();
              this.droplong = this.drop_marker_loc.position.lng();
              this.checkdrop();
              this.drawroute();
              this.fareEstimate();
            }
          );
          this.mappickup_drop_bounds = new google.maps.LatLngBounds();
          this.mappickup_drop_bounds.extend(this.drop_marker_loc.getPosition());
          this.map.fitBounds(this.mappickup_drop_bounds);
          this.map.setZoom(13);
          $("#map_loader_parent").hide();
          if (this.vehicle_types.length != 0) {
            this.fareEstimate();
          }
        });
        if (this.pickup_marker_loc != undefined && this.drop_marker_loc != undefined) {
          this.pickup_marker_loc.setMap(null);
          this.drop_marker_loc.setMap(null);
          this.directionsDisplay.setMap(null);
        }
      }
    }, 300);
  }

  checkpickup() {
    var geocoder = new google.maps.Geocoder;
    var infowindow = new google.maps.InfoWindow;
    var latlngStr = [];
    latlngStr[0] = this.pickuplat;
    latlngStr[1] = this.pickuplong;
    var latlng = { lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1]) };
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      this.getvechicles();
      if (this.droplat == undefined && this.droplong == undefined) {
        this.directionsDisplay.setMap(null);
      } else {
        this.drawroute();
      }
      if (status === 'OK') {
        if (results[0]) {
          this.map.setZoom(11);
          $("#origin-input2").val(results[0].formatted_address);
        } else {
          window.alert(this.booknow.noResults);
        }
      } else {
        window.alert(this.booknow.geoFail + status);
      }
    })
  }

  checkdrop() {
    //TIME CALCULATION GOOGLE API 
    var geocoder = new google.maps.Geocoder;
    var infowindow = new google.maps.InfoWindow;
    var latlngStr = [];
    latlngStr[0] = this.droplat;
    latlngStr[1] = this.droplong;
    var latlng = { lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1]) };
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.map.setZoom(11);
          $("#origin-input3").val(results[0].formatted_address);
        } else {
          window.alert(this.booknow.noResults);
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
      this.drop_loc_bool = true;
    })
  }

  // Draw Route
  drawroute() {

    this.clear_all_vehicles();                                            // Clear all the vechicles when changing pickup or drop
    var origin = new google.maps.LatLng(this.pickuplat, this.pickuplong); // using pickuplat
    var origin2 = new google.maps.LatLng(this.droplat, this.droplong);
    var destination = this.droplat + ', ' + this.droplong;                // using droplat long 

    var directionsService2 = new google.maps.DirectionsService({ preserveViewport: true });
    var request = {
      origin: origin, // LatLng|string
      destination: destination, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING  //TRAVEL MODE
    };

    directionsService2.route(request, (response, status) => {
      if (status === 'OK') {
        var point = response.routes[0].legs[0];                 // SHOWING MAP ROUTE ZOOM BASED ON APPROX DIST
        this.journey_time = point.distance.value;
        this.journey_time = Math.ceil(this.journey_time / 1000);
        this.directionsDisplay.setDirections(response);
        this.directionsDisplay.setMap(this.map);                  // DRAWING MAP ROUTES FROM PICKUP AND DROP FROM RESULT 
        var zoomChangeBoundsListener = google.maps.event.addListenerOnce(this.map, 'bounds_changed', (event) => {
          this.map.panToBounds(this.mappickup_drop_bounds);
          if (this.journey_time <= 100) {
            this.map.setZoom(12);
          }
          else if (this.journey_time > 100 && this.journey_time < 500) {
            this.map.setZoom(8);
          }
          else if (this.journey_time > 500 && this.journey_time < 1500) {
            this.map.setZoom(6);
          }
          else if (this.journey_time > 1500) {
            this.map.setZoom(5);
          }
          google.maps.event.trigger(this.map, 'resize');
        });
        setTimeout(function () { google.maps.event.removeListener(zoomChangeBoundsListener) }, 1000);
      }
    });
  }

  curlat: any;
  curlong: any;
  //current latlong
  latlong() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((e) => {
        var position_marker = new google.maps.LatLng(e.coords.latitude, e.coords.longitude);
        this.curlat = e.coords.latitude;
        this.curlong = e.coords.longitude;
      });
    } else {
    }
  }

  bookForSomeoneEnable1 = false;
  distanceInMeters: any;
  // check someoneelse radius range
  someoneelseRange() {
    const userlatlong = new google.maps.LatLng(this.pickuplat, this.pickuplong);
    const driverlatlong = new google.maps.LatLng(this.curlat, this.curlong);
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [userlatlong, 'destinationA'],
        destinations: [driverlatlong, 'destinationB'],
        travelMode: 'DRIVING',
        avoidHighways: true,
        avoidTolls: true,
      }, (response, status) => {
        console.log('someoneelse', response);
        const distance = response.rows[0].elements[0].distance.value;
        if (this.bookForSomeoneEnable == true && distance > this.isSomeoneEnable) {
          this.bookForSomeoneEnable1 = true;
        } else {
          this.bookForSomeoneEnable1 = false;
        }
      });
  }

  haversine(id, lat, long, callback) {
    const userlatlong = new google.maps.LatLng(this.pickuplat, this.pickuplong);
    const driverlatlong = new google.maps.LatLng(lat, long);
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [userlatlong, 'destinationA'],
        destinations: [driverlatlong, 'destinationB'],
        travelMode: 'DRIVING',
        avoidHighways: true,
        avoidTolls: true,
      }, (response, status) => {
        callback(id, response.rows[0].elements[0].duration.text);
      });
  }

  // Remove Driver Markers
  removeDriverMarker() {
    for (var inst = 0; inst < this.drivers_vehicletype.length; inst++) {
      for (var i = 0; i < this.drivers_vehicletype_markers.length; i++) {
        this.drivers_vehicletype_markers[i].setMap(null);
      }
      this.drivers_vehicletype_markers.length = 0;
    }
  }

  // Set Driver Marker
  setDriverMarker() {
    var icon = {
      url: this.item, // url
      scaledSize: new google.maps.Size(50, 50), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(0, 0) // anchor
    };
    for (var inst = 0; inst < this.drivers_vehicletype.length; inst++) {
      for (var instq = 0; instq < this.drivers_vehicletype[inst].mas.length; instq++) {
        var pos = new google.maps.LatLng(this.drivers_vehicletype[inst].mas[instq].lt, this.drivers_vehicletype[inst].mas[instq].lg)
        var marker = new google.maps.Marker({
          position: pos,
          icon: icon,
          map: this.map
        });
        this.drivers_vehicletype_markers.push(marker);
      }
    }
  }

  orgPricingValue = 0;
  // fare estimation after selecting drop address
  fareEstimate() {
    if (this.veh_id != undefined) {
      var pickup = $("#origin-input2").val();
      var drop = $("#origin-input3").val();
      if (drop != '') {
        this._dispatcherService.surgeprice({
          "vehicleTypeId": this.veh_id,
          "pickupLatLong": this.pickuplat + ',' + this.pickuplong,
          "dropLatLong": this.droplat + ',' + this.droplong,
          "pickup": pickup,
          "drop": drop,
          "bookingType": this.appt_type
        }).subscribe((res) => {
          this.errfare = '';
          this._cookie.setFareEstimate(res.data);
          // this.advanceFee = res.data.laterBookingAdvanceFee;
          this.fareCurrency = res.data.currencySymbol;
          $(".loader_place2").hide();
          this.approx = res.data.duration + ' ' + res.data.timeMetrics;
          this.approx_dist_txt = res.data.distance + ' ' + res.data.distanceMetrics;
          this.orgPricingValue = parseInt(res.data.finalAmount);
          this.pricingType = res.data.finalAmount;
          $('#approx').text(res.data.duration + ' ' + res.data.timeMetrics);
          $('#approx_dist').text(res.data.distance + ' ' + res.data.distanceMetrics);
          $('#est_journey').text(res.data.currencySymbol + ' ' + res.data.finalAmount);
          // if(this.appt_type == 2) {
          //   this.bookLaterFunction();
          // }
          // $('#approx').text(this.approx);
          // $('#approx_dist').text(this.approx_dist_txt);
          // $('#est_journey').text(this.pricingType);
          $('.promocodeParent button').removeAttr('disabled');
          if (res.errNum == 400) {
            $("#error_popup_parent2").show();
          }
          $('#origin-input3').trigger('click');
        },
          (err) => {
            if (err.status > 401 && err.status < 500) {
              err.status = 420; // merging all the status codes to one status code 420
            }
            if (err.status > 499) {
              err.status = 520; // merging all the status codes to one status code 420
            }
            switch (err.status) {
              case 520:
                $(".loader_place2").hide();
                this.errMsg = JSON.parse(err._body);
                toastr["error"](this.errMsg.message);
                break;
              case 400:
                $(".loader_place2").hide();
                this.errMsg = JSON.parse(err._body);
                toastr["error"](this.errMsg.message);
                break;
              case 401:
                this._cookie.removeItem();
                this._router.navigate(['login']);
                break;
              case 404:
                $(".loader_place2").hide();
                this.errMsg = JSON.parse(err._body);
                toastr["error"](this.errMsg.message);
                break;
              case 420:
                $(".loader_place2").hide();
                setTimeout(() => {
                  this.errfare = JSON.parse(err._body);
                  swal("ERROR", this.errfare.message);
                  this.errfare = this.errfare.message;
                }, 500);

                this.drop_marker_loc.setMap(null);
                this.directionsDisplay.setMap(null);
                $('#origin-input3').attr("value", "");
                $('#drop_address .remove_details').removeClass('has-success');
                $('#drop_address .remove_details').addClass('has-error');
                break;
            }
          });
      }
    }
  }

  difference(arr1, arr2) {
    const temp = [];
    arr1 = this.vehicle_types1;
    arr2 = this.vehicle_types;
    for (var i in arr1) {
      if (!arr2.includes(arr1[i])) temp.push(arr1[i]);
    }
    for (i in arr2) {
      if (!arr1.includes(arr2[i])) temp.push(arr2[i]);
    }
    return temp.sort((a, b) => a - b);
  }

  // Get Vehicles
  getvechicles() {
    this.interval = this._cookie.getConfig('customerApiInterval');
    let timeout = this.interval * 1000;
    this.vehicle_types = [];
    this.vehicles_api();
  }

  // Special Pickup
  specialfun(item) {
    if (this.specialpickupmarker != undefined) {
      this.pickup_marker_loc.setMap(null);
      this.specialpickupmarker.setMap(null);
      this.directionsDisplay.setMap(null);
    }
    const index = this.speciallatlong.findIndex(array => array.id === item.target.value);
    // this.specialAddress = this.pickups[index].title;
    // this.own_lat_long = this.own_lat_long + ',' + this.pickups[index].title;
    this.speciallat = this.speciallatlong[index].location.latitude;
    this.speciallong = this.speciallatlong[index].location.longitude;
    this.pickuplat = this.speciallat;
    this.pickuplong = this.speciallong;
    var pickup = $("#origin-input2").val();
    this.own_lat_long = pickup + ', ' + this.pickups[index].title;

    var myLatLng = { lat: this.speciallat, lng: this.speciallong };
    this.specialpickupmarker = new google.maps.Marker({
      position: myLatLng,
      icon: myGlobals.pickupicn,
      map: this.map
    });
    this.drawroute();
    this.specialpickupmarker.setMap(this.map);
    this.map.setZoom(14);
    // this.fareEstimate();
  }

  // getting favorite driver
  favDriverId: any;
  driverImage: any;
  favDrivers = [];
  getfavdriver(id) {
    this._dispatcherHomeService.getfavdriver({
    }).subscribe((res) => {
      for (let i = 0; i < res.data.length; i++) {
        this.driverImage = res.data[i].name.toString();
        const online = res.data[i].isOnline;
        if (online == true) {
          this.favDrivers.push(res.data[i]);
          if (id == res.data[i].driverId) {
            $('#favDriver').modal('show');
          } else {
          }
        }
      }
    });
  }

  walletenabled = false;
  speciallatlongs = [];
  cityId: any;
  // Get Online Vehicles
  vehicles_api() {
    let onlineId;
    let prearray = [];
    if (this.vehicle_types.length == 0) {
      $('#task_des').trigger('click');
      setTimeout(() => {
        $(".loader_vechicles").hide();
      }, 1000);
      this.vehicle_type_load = true;
    }
    this._dispatcherService.vehicles({
      lt: this.pickuplat.toString(),
      lg: this.pickuplong.toString(),
    }).subscribe((res) => {
      if (res.data.vehicleTypes.length == 0) {
        $(".loader_vechicles").hide();
        // this.errvehicles1 = res.data.message;
        this.errvehicles1 = 'Sorry we don’t operate in your area yet, please contact https://zoom.cab/ to request our services...';
      } else {
        this.errvehicles1 = '';
        this.cashEnable = res.data.cityData.isCashEnable;
        this.cardEnable = res.data.cityData.isCardEnable;
        this.walletenabled = res.data.walletData.isWalletEnable;
        this.isSomeoneEnable = res.data.cityData.radiusforsomeOneElseBooking;
        this.corporate = res.data.cityData.isCorporateEnable;
        this.cityId = res.data.cityData.cityId;
        // special pickups
        this.specialPickup = false;
        this.pickups = res.data.areaZone.pickups;
        let polypath;
        if (res.data.areaZone.pointsProps != undefined) {
          polypath = res.data.areaZone.pointsProps.paths;
        }
        this.speciallatlong = this.pickups;
        if (this.pickups != undefined) {
          this.pickup_marker_loc.setMap(null);
          this.specialPickup = true;
          for (let inst = 0; inst < this.pickups.length; inst++) {
            var circle = {
              path: google.maps.SymbolPath.CIRCLE,
              // fillColor: res.data.areaZone.pointsProps.fillColor,
              // fillOpacity: res.data.areaZone.pointsProps.fillOpacity,
              // strokeColor: res.data.areaZone.pointsProps.strokeColor,
              // strokeWeight: res.data.areaZone.pointsProps.strokeWeight,
              scale: 4.5,
              fillOpacity: .4,
              fillColor: '#37ff00',
              strokeColor: '#37ff00',
              strokeWeight: 1
            };
            var lat = this.pickups[inst].location.latitude;
            var long = this.pickups[inst].location.longitude;
            var location = { lat: lat, lng: long };
            this.locs.push(location);
            const specialMarker = new google.maps.Marker({
              position: location,
              icon: circle,
              map: this.map
            });
            this.dotmarker.push(specialMarker);
            this.map.setZoom(17);

            // var lat = polypath[inst].lat;
            // var long = polypath[inst].lng;
            // var location1 = { lat: lat, lng: long };
            // this.speciallatlongs.push(location1);
            this.polymarker = new google.maps.Polyline({
              path: this.locs,
              geodesic: true,
              // strokeColor: res.data.areaZone.pointsProps.strokeColor,
              // strokeOpacity: res.data.areaZone.pointsProps.strokeOpacity,
              // strokeWeight: res.data.areaZone.pointsProps.strokeWeight
              strokeColor: '#FF0000',
              strokeOpacity: 1.0,
              strokeWeight: 2
            });
            this.polymarker.setMap(this.map);
            this.map.setZoom(17);
          }

          // for(let inst1 = 0; inst1 < polypath.length; inst1++) {
          //   var latitude = polypath[inst1].lat;
          //   var longitude = polypath[inst1].lng;
          //   var latlongs = {lat: latitude, lng: longitude};
          //   var speciallatlongs = [];
          //   speciallatlongs.push(latlongs);
          //   console.log('special latlongs------------>', speciallatlongs);
          //   this.polymarker = new google.maps.Polyline({
          //     path: speciallatlongs,
          //     geodesic: true,
          //     // strokeColor: res.data.areaZone.pointsProps.strokeColor,
          //     // strokeOpacity: res.data.areaZone.pointsProps.strokeOpacity,
          //     // strokeWeight: res.data.areaZone.pointsProps.strokeWeight
          //     strokeColor: '#FF0000',
          //     strokeOpacity: 1.0,
          //     strokeWeight: 2
          //   });
          //   this.polymarker.setMap(this.map);
          //   this.map.setZoom(17);
          // }
        }

        if (this.vehicle_types.length == 0) {
          for (var inst = 0; inst < res.data.vehicleTypes.length; inst++) {
            if (res.data.vehicleTypes[inst].drivers.length > 0) {
              this.haversine(res.data.vehicleTypes[inst].typeId, res.data.vehicleTypes[inst].drivers[0].latitude, res.data.vehicleTypes[inst].drivers[0].longitude, (id, res) => {
                const index = this.vehicle_types.findIndex(i => i.typeId == id);
                this.vehicle_types[index].time = res;
              });
              //res.data.vehicleTypes[inst].time = this.haversine(res.data.vehicleTypes[inst].drivers[0].latitude, res.data.vehicleTypes[inst].drivers[0].longitude) ;
              onlineId = res.data.vehicleTypes[0].typeId;
              this.advanceFee = res.data.vehicleTypes[0].ride.laterBookingAdvanceFee;
              // for (let i = 0; i < res.data.vehicleTypes[inst].drivers.length; i++) {
              //    this.getfavdriver(res.data.vehicleTypes[inst].drivers[i].masterId);
              // }
            } else {
              res.data.vehicleTypes[inst].time = 'No Drivers'
            }
            prearray.push(res.data.vehicleTypes[inst]);
          }
          // prearray.sort(function (a, b) {
          //   if (a.typeName < b.typeName) return -1;
          //   if (a.typeName > b.typeName) return 1;
          //   return 0;
          // })
          this.vehicle_types = prearray;
          $(".task_des1").trigger('click');
          setTimeout(() => {
            $('#cb' + onlineId).trigger('click');
            if (this.droplat != undefined && this.droplat != '') {
              this.fareEstimate();
            } else {

            }
          }, 500);
          if (res.data.vehicleTypes.length < 1) {
            $('#nodrivers').text('Currently there are No Drivers Available');
          }
          for (var inst = 0; inst < res.data.vehicleTypes.length; inst++) {
            if (res.data.vehicleTypes[inst].time == 'No Drivers') {
              this.booknowbutton = false;
              this.booklaterbutton = true;
            } else {
              this.booknowbutton = false;
              this.booklaterbutton = true;
            }
          }
        }
        this.vehicle_type_load = false;
      }
    },
      (err) => {
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".loader_vechicles").hide();
            toastr["error"]("Server Not Responding!");
            break;
          case 520:
            $(".loader_vechicles").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_vechicles").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_vechicles").hide();
            this.errvehicles = JSON.parse(err._body);
            swal("ERROR", this.errvehicles.message);
            this.errvehicles = this.errvehicles.message;
            break;
        }
      });
  }

  // Set Driver Marker
  driverMarker(item) {
    if (item.drivers != undefined) {
      if (item.drivers.length) {
        var pos = { lat: item.drivers[0].latitude, lng: item.drivers[0].longitude };
        var icon = {
          url: item.vehicleMapIcon, // url
          scaledSize: new google.maps.Size(30, 30), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
        };
        this.driver_marker_loc = new google.maps.Marker({
          icon: icon,
          position: pos,
          map: this.map
        });
        this.driver_marker_loc.setMap(this.map);
      }
    } else {
      if (item.length) {
        var pos = { lat: item[0].latitude, lng: item[0].longitude };
        var icon = {
          url: item.profilePic, // url
          scaledSize: new google.maps.Size(30, 30), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
        };
        this.driver_marker_loc = new google.maps.Marker({
          icon: icon,
          position: pos,
          map: this.map
        });
        this.driver_marker_loc.setMap(this.map);
      }
    }
  }

  favoriteDriverId = [];
  // Change favorite driver vehicles
  changeFavoriteVehicles(item, val) {
    this.favoriteDriverId = [];
    switch (val) {
      case 1:
        this.favoriteDriverId.push(item.masterId);
        break;
      case 2:
        for (let inst = 0; inst < this.favDrivers.length; inst++) {
          if (this.favDrivers[inst].isFavouriteDriver == true) {
            this.favoriteDriverId.push(this.favDrivers[inst].masterId);
          }
        }
        break;
      case 3:
        break;

    }
  }

  // Change Vehicle Type
  changeVehicles(item, id, icn) {
    this.favDrivers = [];
    for (let inst = 0; inst < item.drivers.length; inst++) {
      if (item.drivers[inst].isFavouriteDriver == true) {
        this.favDrivers.push(item.drivers[inst]);
      }
    }
    if (this.favDrivers.length > 0) {
      $('#favDriver').modal({ backdrop: 'static', keyboard: false });
    }
    this.veh_id = item.typeId;
    this.show_dropaddress = item.ride.isDropLocationMandatory;
    this.advanceFee = item.ride.laterBookingAdvanceFee;
    if (item.drivers.length > 0) {
      this.enableBooknow = true;
      this.enableBooklater = true;
    } else {
      this.enableBooknow = false;
      this.enableBooklater = true;
    }
    if (this.driver_marker_loc != undefined) {
      this.driver_marker_loc.setMap(null);
      this.driver_marker_loc = undefined;
    }
    this.driverMarker(item);

    if (this.droplat != '' && this.droplat != undefined && this.pickuplat != '' && this.pickuplat != undefined) {
      this.fareEstimate();
    }
    if (this.pickuplat == '' || this.pickuplat == undefined) {
      alert(this.disphome.validAdd);
    }
    else {
      for (var inst = 0; inst < this.vehicle_types.length; inst++) {
        if (this.vehicle_types[inst].type_id == item.type_id) {
          this.vehicle_types[inst].show_onimage = 1;
        }
        else {
          this.vehicle_types[inst].show_onimage = 0;
        }
      }
      $(".vehicle_img_" + item.type_id).attr('src', item.vehicle_img);
      // rate card
      this.show_ratecard = true;
      this.capacity = item.ride.baseFare;
      this.length_var = item.ride.mileagePrice;
      this.fare = item.ride.timeFare;
      // seating capacity
      let capacity = item.ride.seatingCapacity;
      this.numSeats = [];
      for (let i = 1; i <= capacity; i++) {
        this.numSeats.push(i);
      }
      var classes = $('.vehicle_type_blocks').length;
      if (classes > 1) {
        $(".vehicle_type_blocks").removeClass('show_high');
        $(".vehicle_type_blocks").toggleClass('move_top');
        $("#vehicle_" + id).addClass('show_high');
      }
      else {
      }
    }
    this.preferences();
  }

  // Get Payment Details
  paymentDetails() {
    this._dispatcherService.paymentDetails({
    }).subscribe((res) => {
      this.show_payment = true;
      if (res.data.enableWallet == false) {             // enable wallet 
        if (this.payment_type == 0 && this.payment_type != undefined) {
          this.show_wallet = false;
        } else {
          this.show_wallet = false;
          this.show_cards = true;
          this.payment_type = 1;
          $('#s-option2').trigger('click');
        }
      }
      else {
        this.show_wallet = true;
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 520:
            this.show_wallet = false;
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.show_wallet = false;
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            this.show_wallet = false;
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      })
  }

  // app config function api 
  appconfig_url() {
    $('#task_des').trigger('click');
    setTimeout(() => {
      $(".loader_vechicles").hide();
    }, 1000);
    this._dispatcherService.appconfig({
    }).subscribe((res) => {
      this.bookForSomeoneEnable = res.data.isBookingForSomeoneElseEnable;
      this.getcorporate();
      $("#s-option6").trigger('click');
      $('#corporatedetails').hide();
      $('#someoneelse').hide();
      this.show_payment = true;
      clearInterval(this.vehicles_interval);
      this.booknowbutton = true;
      this.booklaterbutton = true;
      this._cookie.setConfig(res.data);
      this._cookie.getItem('token');
      this.booklater_date(res.data.rideLaterBookingAppBuffer);
      if (this.current_lat == undefined || this.current_lat == '') {
        this.currentlat();
      }
      this.show_default_cards();
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not Responding!");
            break;
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this.errMsg = JSON.parse(err._body);
            this._cookie.removeItem();
            this._router.navigate(['login']);
            toastr["warning"](this.errMsg.message + "<br> You have been Logged out!");
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  // selectGender(e) {
  //   this.gender = e.target.selectedIndex;
  // }

  // check last due
  checkLastDue() {
    if (this.payment_type != 3) {
      $(".booking_loader_parent").show();
      this._dispatcherService.lastDue({
      }).subscribe((res) => {
        $(".booking_loader_parent").hide();
        if (res.data.isLastDueAvailable == true) {
          swal({
            title: res.data.lastDueMsg,
            text: res.data.pickupAddress + "\n" + res.data.businessName + ", " + res.data.bookingDate,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          },
            (isConfirm) => {
              if (isConfirm) {
                if (this.appt_type == 1) {
                  this.booknowRideApiCall();
                } else {
                  $("#booklater_datepicker").modal('show');
                }
              }
            });
        } else {
          if (this.appt_type == 1) {
            this.booknowRideApiCall();
          } else {
            $("#booklater_datepicker").modal('show');
          }
        }
      })
    } else {
      this.booknowRideApiCall();
    }
  }

  // Call Booking API By Checking Pickup & Drop Address
  booknowRide() {
    this.appt_type = 1;
    // this.fareEstimate();
    this.bookingDate = moment().format('YYYY-MM-DD HH:mm:ss');
    if (this.show_dropaddress) {
      if (this.droplat != '' && this.droplat != undefined) {
        if (this.payment_type == 1 && this.card_number == '') {
          swal("WARNING", "Please Add the Card!", "error");
        } else {
          this.checkLastDue();
        }
      } else {
        $('#drop_address').removeClass('has-success');
        $('#drop_address').addClass('has-error');
        $('#origin-input3').focus();
        swal("ERROR", "Drop Address is Mandatory !", "error");
      }
    } else {
      if (this.payment_type == 1 && this.card_number == '') {
        swal("WARNING", "Please Add the Card!", "error");
      } else {
        this.checkLastDue();
      }
    }
  }

  bookingId: any;
  // Book Now Ride API
  booknowRideApiCall() {
    console.log('drop latlongs---->', this.droplat, this.pricingType);
    if (this.droplat != '' || this.droplat != undefined) {
      if (this.pricingType == undefined) {
        this.pricingType = '0';
        this.timeFare = '0';
        this.distFare = '0';
        this.distance = '0';
        this.duration = '0';
      } else {
        this.timeFare = this._cookie.getFareEstimate('timeFee');
        this.distFare = this._cookie.getFareEstimate('distanceFee');
        this.distance = this._cookie.getFareEstimate('distance');
        this.duration = this._cookie.getFareEstimate('duration')
      }
    }
    this.date = moment().format('YYYY-MM-DD HH:mm:ss');
    $(".select_cards").removeClass('has-error');
    var devid = this._cookie.getItem('devid');
    if (this.credit_no_book == true) {
      $(".booking_loader_parent").hide();
      $("#credit_popup_parent").show();
    } else {
      $(".booking_loader_parent").show();
      this._dispatcherService.booknowRide({
        favoriteDriverId: this.favoriteDriverId.toString(),
        vehicleTypeId: this.veh_id,
        paymentType: this.payment_type,
        payByWallet: this.walletPay,
        bookingType: this.appt_type,
        deviceId: 'web',
        deviceType: 2,
        bookingDate: this.bookingDate,
        deviceTime: this.date,
        amount: this.pricingType,
        timeFare: this.timeFare,
        distFare: this.distFare,
        distance: this.distance,
        duration: this.duration,
        pickupAddress: this.own_lat_long,
        pickupLongitude: this.pickuplong.toString(),
        pickupLatitude: this.pickuplat.toString(),
        dropAddress: this.own_drop_latlong,
        dropLatitude: this.droplat,
        dropLongitude: this.droplong,
        numOfPassanger: this.seats,
        isSomeOneElseBooking: this.isSomeOneElseBooking,
        customerName: this.customerName,
        customerNumber: this.customerNumber,
        cardId: this.cardId,
        cardType: this.cardType,
        paymentGatewayName: this.paymentGatewayName,
        instituteUserId: this.corporateId,
        serviceType: 2,
        bookingPreference: this.checkedDriverpref.toString()
      }).subscribe((res) => {
        this.bookingId = res.data.bookingId;
        this._cookie.setBookNow(res.data);
        if (this.appt_type == 2) {
          this.bookingRequestTimeRide = 0;
        } else {
          this.bookingRequestTimeRide = res.data.bookingRequestTimeRide;
        }
        this.bookTimeout = setTimeout(() => {
          $(".booking_loader_parent").hide();
          $('#cancel').modal('hide');
        }, this.bookingRequestTimeRide * 1000);
        this.bookcancel = true;
        $("#myModal").modal('hide');
        setTimeout(() => {
          $("#hidden_btn").trigger('click');
          $("#tasks_refresh").trigger('click');
        }, 300);
      },
        (err) => {
          console.log('errMsg', err.status);
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              toastr["error"]("Server Not responding!");
            case 520:
              $(".booking_loader_parent").hide();
              this.errMsg = JSON.parse(err._body);
              toastr["error"](this.errMsg.message);
              break;
            case 400:
              $(".booking_loader_parent").hide();
              this.errMsg = JSON.parse(err._body);
              toastr["error"](this.errMsg.message);
              break;
            case 401:
              this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 420:
              $(".booking_loader_parent").hide();
              this.errmessage = JSON.parse(err._body);
              this.errmessage = this.errmessage.message;
              setTimeout(() => {
                this.errmessage = '';
              }, 5000);
              break;
          }
        });
    }
  }

  promoWallet: any;
  promoPaymentType: any;
  // Promocode Code Verification
  promoCodeChanged() {
    if (this.pickuplat != '' || this.pickuplat != undefined && this.pricingType != '' || this.pricingType != undefined) {
      $(".promocodeParent").addClass('has-error');
      $(".promocodeParent").removeClass('has-success');
      $(".promocodeParent #err").hide();
      $(".loader_promo").hide();
      this._dispatcherService.verifypromo({
        latitude: parseFloat(this.pickuplat),
        longitude: parseFloat(this.pickuplong),
        amount: parseFloat(this.pricingType),
        vehicleTypeId: this.veh_id,
        paymentMethod: this.payment_type,
        payByWallet: this.walletPay,
        couponCode: this.promoCode
      }).subscribe((res) => {
        this.promoWallet = res.data.payByWallet;
        this.promoPaymentType = res.data.paymentType;
        $(".loader_promo").hide();
        $(".promocodeParent").addClass('has-success');
        $(".promocodeParent").removeClass('has-error');
      }, (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 520:
            $(".loader_promo").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_promo").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 420:
            this.verifyPromo = JSON.parse(err._body);
            this.verifyPromo = this.verifyPromo.message;
            console.log(this.verifyPromo);
            $(".loader_promo").hide();
            setTimeout(() => {
              $(".promocodeParent #err").show();
            }, 300);

            $(".promocodeParent").removeClass('has-success');
            $(".promocodeParent").addClass('has-error');
            break;
        }
      });
    } else {
      $('#drop_address').addClass('has-error');
      $('#origin-input2').focus();
      swal("ERROR", "Please enter pickup and drop address!", "error");
    }
  }

  // Cancel Booking
  bookingsCancel() {
    var bookingId = this._cookie.getBookNow('bookingId');
    this._dispatcherService.cancelBooking({
      bookingId: bookingId
    }).subscribe((res) => {
      this.bookcancel = false;
      $(".booking_loader_parent").hide();
    },
      (err) => {
        $('.booking_loader_parent').hide();
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not responding!");
          case 520:
            $(".booking_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".booking_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".booking_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      });
  }

  loaderClose() {
    this.bookcancel = false;
    $(".booking_loader_parent").hide();
  }

  // start payment settings
  // Get Cards
  show_default_cards() {
    this._dispatcherService.getcards({
    }).subscribe((res) => {
      this.cardsDetails = res.data;
      // set card id, type, gateway name
      for (let inst = 0; inst < this.cardsDetails.cards.length; inst++) {
        if (this.cardsDetails.cards[inst].isDefault) {
          this.cardId = this.cardsDetails.cards[inst].id;
          this.cardType = this.cardsDetails.cards[inst].funding;
          this.paymentGatewayName = "Stripe";
        } else {
          this.cardId = this.cardsDetails.cards[inst].id;
        }
      }
      this.display = false;
      $(".loader_cardadd_parent").hide();
      this.allcards = res.data.cards;
      if (this.allcards.length > 0) {
        for (var inst = 0; inst < this.allcards.length; inst++) {
          if (this.allcards[inst].isDefault == true) {
            this.card_number = this.allcards[inst].id;
            this.last_card_number = this.allcards[inst].last4;
            this.stripe_lastCard = this.allcards[inst].last4;
            this.stripe_cardType = this.allcards[inst].funding;
            break;
          }
        }
      } else { this.card_number = ''; }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_cardadd_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  // change default card
  changeDefault(val) {
    this.cardId = val;
    this.changecards();
  }

  // Change Default Card
  changecards() {
    $(".loader_cardadd_parent").show();
    this._dispatcherService.changecards({
      cardId: this.cardId
    }).subscribe((res) => {
      $(".loader_cardadd_parent").hide();
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_cardadd_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  // Open Cards
  open_card() {
    $(".loader_cardadd_parent").hide();
    $('.select_card_button').trigger('click');
    this._dispatcherService.getcards({
    }).subscribe((res) => {
      if (res.errFlag == 0) {
        $(".loader_cardadd_parent").hide();
        this.allcards = res.data;
        if (this.allcards.length < 1) {
          $("#new_cards_div").show();
          $('#card-number').focus();
        }
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_cardadd_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
    $("#credit_card_popup").modal('show');
    if (this.allcards.length < 1) {
      this.show_add_card = true;
    }
  }

  // Add New Card
  addcards(cardid) {
    $(".card_error_msg").remove();
    $(".month_error_msg").remove();
    $(".loader_cardadd_parent").show();
    this._dispatcherService.addcards({
      email: this._cookie.getItem('email'),
      cardToken: cardid
    }).subscribe((res) => {
      $(".select_card_button").trigger('click');
      this.cardsDetails = res.data;
      this.open_card();
      $('#card-expiration-month option:selected').val();
      $("#card-expiration-month").val($("#card-expiration-month option:first").val());
      $("#card-expiration-year").val($("#card-expiration-year option:first").val());
      $(".ccv div,.card-expiration-date div,.credit-card-box .card-holder div,.credit-card-box .number").empty();
      $("#credit_card_popup input").val('');
      $(".loader_cardadd_parent").hide();
      $(".select_card_button").trigger('click');
      $("#new_cards_div").hide();
      this.card_number = '';
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not Responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_cardadd_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  // Delete Card
  deleteCard(cardid) {
    this.last_card_number = "";
    this._dispatcherService.deletecard({
      cardId: cardid
    }).subscribe((res) => {
      this.show_default_cards();
      for (var inst = 0; inst < this.allcards.length; inst++) {
        if (this.allcards[inst].id == cardid) {
          this.allcards.splice(inst, 1);
          break;
        }
      }
      $(".loader_cardadd_parent").hide();
      if (this.allcards.length < 1) {
        $("#new_cards_div").show();
        $('#card-number').focus();
      }
    });
  }

  // Stripe Card
  stripe_cardadd() {
    $(".card_error_msg").remove();
    $(".month_error_msg").remove();
    var card = $("#card-number").val() + $("#card-number-1").val() + $("#card-number-2").val() + $("#card-number-3").val();
    var mm = $('#card-expiration-month option:selected').val();
    var yy = $('#card-expiration-year option:selected').val();
    if (card.length < 14 || mm == "00" || yy == "00") {
      if (card.length < 14)
        $(".card_number_valid").append('<span class="card_error_msg">' + this.disphome.validCardNum + '</span>');
      else
        $(".fieldset-expiration").append('<span class="month_error_msg">' + this.disphome.validExpiry + '</span>');
    }
    else {
      $(".card_error_msg").remove();
      $(".month_error_msg").remove();
      $(".loader_cardadd_parent").show();
      var stripekey = this._cookie.getConfig('stripe');
      Stripe.setPublishableKey(stripekey);
      Stripe.createToken({
        number: parseInt(this.card_number_all),
        cvc: parseInt(this.card_cvc),
        exp_month: (this.card_month).toString(),
        exp_year: (this.card_year).toString()
      }, (status, response) => {
        if (response['id'] != undefined) {
          this.addcards(response['id']);
          this.show_default_cards();
        }
        else {
          $(".error_card_msg").css('color', 'red');
          $(".error_card_msg").text(response.error.message);
          setTimeout(() => {
            $(".error_card_msg").text('');
          }, 2000);
          $(".loader_cardadd_parent").hide();
        }
      })
    }
  }

  // Credit Limit
  creditlimit() {
    this._dispatcherService.creditlimit({}).subscribe((res) => {
      if (res.errNum == 45) {
        $("#credit_popup_parent").show();
        this.credit_error_msg = res.errMsg;
        this.soft_limit_error = true;
        this.hard_limit_error = false;
        this.credit_no_book = false;
      }
      else if (res.errNum == 46) {
        $("#credit_popup_parent").show();
        this.credit_error_msg = res.errMsg;
        this.hard_limit_error = true;
        this.soft_limit_error = false;
        this.credit_no_book = true;
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not Responding!");
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  // Get Wallet Details
  wallet() {
    this._dispatcherService.wallet({}).subscribe((res) => {
      this._cookie.setWalletDetails(res.data);
      this.currency = res.data.currencySymbol;
      this.showing_balance = res.data.walletBalance;
      this.walletEnable = res.data.isEnabled;
    });
  }

  // end of payment settings

  // Logout
  loggout() {
    this._dispatcherService.loggedout({
    }).subscribe((res) => {
      this._cookie.removeItem();
      this._router.navigate(['login']);
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            toastr["error"]("Server Not Responding!");
          case 520:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      });
  }

  // LIVE BOOKING API
  addinfo() {

  }

  // Book Later Date Picker
  booklater_date(laterTime) {
    var later = laterTime / 60;          // later time from config                              // convert
    var later_time = moment().add(later, 'm');                  // using moment add later and formatting to later pickup time
    later_time = moment(later_time).format();
    flatpickr(".flatpickr5", {
      defaultDate: 1477697199863, // Date objects and date strings are also accepted
      enableTime: true,
      enableSeconds: true,
      minDate: later_time,
      // maxDate: "2018-12-20",
      altFormat: "M j, Y",
      dateFormat: "F j, Y h:i K",
      inline: true,
      minuteIncrement: 30
    });
  }

  // START OF CORPORATE ACCOUNT API
  corporateId: any;
  // Get Corporate Details
  getcorporate() {
    this._dispatcherService.getcorporate({
    }).subscribe((res) => {
      this.corporates = res.data;
      if (this.corporates.length > 0) {
        this.selectcorporate = true;
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".loader_cardadd_parent").hide();
            toastr["error"]("Server Not responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".loader_cardadd_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            setTimeout(() => {
              this.errmessage = '';
            }, 5000);
            break;
        }
      });
  }

  onCorporate(item) {
    const index = this.corporates.findIndex(array => array.instituteName === item.target.value);
    if (index != -1) {
      if (this.droplat != undefined && this.droplat != '') {
        this.corporateId = this.corporates[index].userId;
      } else {
        $('#origin-input3').addClass('has-error');
        $('#origin-input3').focus();
        swal("ERROR", "Please enter drop address!", "error");
      }
    } else {
      this.corporateId = '';
    }
  }

  // Verify Corporate Details
  verifycorporate() {
    this._dispatcherService.verifycorporate({
      email: this.corporatemail
    }).subscribe((res) => {
      this.enableBooknow = true;
      this.enableBooklater = true;
      this.corporatemail = '';
      swal({
        title: "success",
        text: res.message,
        type: "success"
      });
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".loader_cardadd_parent").hide();
            toastr["error"]("Server Not responding!");
          case 520:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".loader_cardadd_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $('#corporate_origin').removeClass('has-success');
            $('#corporate_origin').addClass('has-error');
            $(".loader_cardadd_parent").hide();
            this.corporateerr = JSON.parse(err._body);
            let splitted = this.corporateerr.message.split(",", 2);
            this.corporateerr = splitted[0];
            console.log(this.corporateerr);
            setTimeout(() => {
              this.corporateerr = '';
              $('#corporatedetails #err').hide();
            }, 2000);
            break;
        }
      });
  }
  driverPref = [];
  // dynamic driver preferences
  preferences() {
    this._dispatcherService.preference({
      cityId: this.cityId,
      typeId: this.veh_id,
      serviceType: 2
    }).subscribe((res) => {
      this.enablepreferences = true;
      if (this.driverPref.length == 0) {
        for (let driverpre = 0; driverpre < res.data.length; driverpre++) {
          res.data[driverpre].checked = false;
          this.driverPref.push(res.data[driverpre]);
        }
      }
    })
  }
  enablePref() {
    $("#driverPreference").modal('show');
    setTimeout(() => {
      for (let inst = 0; inst < this.checkedDriverpref.length; inst++) {
        const elementref = $('#' + this.checkedDriverpref[inst]);
        elementref[0].checked = true;
      }
    }, 100);
  }
  applyPref() {
    this.checkedDriverpref = [];
    this.pricingType = this.orgPricingValue.toFixed(2);
    $("#driverPreference").modal('hide');
    var classLength = $('.prefInput').length;
    for (var insti = 0; insti < classLength; insti++) {
      const element = $('.prefInput');
      if (element[insti].checked) {
        const idofpreferf = element[insti].id;
        this.checkedDriverpref.push(idofpreferf);
      }
    }
    if (this.checkedDriverpref.length > 0) {
      this.addpref = false;
      for (let inst = 0; inst < this.checkedDriverpref.length; inst++) {
        let index = this.driverPref.findIndex(arr => arr.id == this.checkedDriverpref[inst]);
        if (index != -1) {
          this.driverPref[index].checked = true;
          this.pricingType = (Number(this.pricingType) + this.driverPref[index].fees).toFixed(2);
        }
      }
    } else {
      this.addpref = true;
    }
  }
  cancelPref() {
    var classLength = $('.prefInput').length;
    for (var insti = 0; insti < classLength; insti++) {
      const element = $('.prefInput');
      element[insti].checked = false
    }
    if (this.checkedDriverpref.length > 0) {
      this.addpref = false;
    }
  }

  // END OF CORPORATE ACCOUNT API

  // END OF UBER FOR ALL NEW DISPATCHER CODE
}



// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/dispatcher.component.ts